(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["case-study"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('case-study')) {
    class CaseStudy extends HTMLElement {
      elements;
      slider;
      sid;

      constructor(sid) {
        super();

        this.sid = sid;
      }
  
      initSlider = () => {
        const sid = this.sid;

        this.slider = new Swiper(`#shopify-section-${this.sid} [data-case-study-slider].swiper`, {
          a11y: true,
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          autoheight: false,
          freeMode: true,
          navigation: {
            enabled: true,
            nextEl: `#shopify-section-${this.sid} .swiper-button-next`,
            prevEl: `#shopify-section-${this.sid} .swiper-button-prev`,
          },
          on: {
            init: function () {
              const slider_element = document.querySelector(`#shopify-section-${sid} [data-case-study-slider].swiper`);
              const total_slides = Number(slider_element.dataset.totalSlides);
              const current_index = this.realIndex;
              const previous_index = (this.realIndex === 0) ? (total_slides - 1) : this.realIndex - 1;
              const next_index = (this.realIndex + 1 > total_slides - 1) ? 0 : this.realIndex + 1;

              slider_element.parentElement.querySelector('.swiper-button-prev [data-title]').innerHTML = slider_element.querySelector(`[data-swiper-slide-index="${previous_index}"]`).dataset.slideTitle;
              slider_element.parentElement.querySelector('.swiper-button-next [data-title]').innerHTML = slider_element.querySelector(`[data-swiper-slide-index="${next_index}"]`).dataset.slideTitle;
            },
            slideChangeTransitionStart: function () {
              const slider_element = document.querySelector(`#shopify-section-${sid} [data-case-study-slider].swiper`);
              const total_slides = Number(slider_element.dataset.totalSlides);
              const current_index = this.realIndex;
              const previous_index = (this.realIndex === 0) ? (total_slides - 1) : this.realIndex - 1;
              const next_index = (this.realIndex + 1 > total_slides - 1) ? 0 : this.realIndex + 1;

              slider_element.parentElement.querySelector('.swiper-button-prev [data-title]').innerHTML = slider_element.querySelector(`[data-swiper-slide-index="${previous_index}"]`).dataset.slideTitle;
              slider_element.parentElement.querySelector('.swiper-button-next [data-title]').innerHTML = slider_element.querySelector(`[data-swiper-slide-index="${next_index}"]`).dataset.slideTitle;
            },
          }
        });
      };
    }

    customElements.define('case-study', CaseStudy);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('content-slider')) {
    class ContentSlider extends HTMLElement {
      elements;
      slider;
      sid;

      constructor(sid) {
        super();

        this.sid = sid;

        this.elements = {
          slider: document.querySelector(`#shopify-section-${this.sid} [data-content-slider].swiper`),
        };
      }
  
      initSlider = () => {
        this.slider = new Swiper(`#shopify-section-${this.sid} [data-content-slider].swiper`, {
          a11y: true,
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          autoheight: false,
          freeMode: false,
          autoplay: {
            delay: 50000,
          },
          pagination: {
            el: `#shopify-section-${this.sid} .swiper-pagination`,
            clickable: true,
          },
        });
      };
    }

    customElements.define('content-slider', ContentSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-study"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-study')) {
    class FeaturedStudy extends HTMLElement {
      elements;
      slider;
      sid;

      constructor(sid) {
        super();

        this.sid = sid;

        this.elements = {
          slider: document.querySelector(`#shopify-section-${this.sid} [data-featured-study-slider].swiper`),
        };
      }
  
      initSlider = () => {
        this.slider = new Swiper(`#shopify-section-${this.sid} [data-featured-study-slider].swiper`, {
          a11y: true,
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          autoheight: false,
          freeMode: true,
          pagination: {
            el: `#shopify-section-${this.sid} .swiper-pagination`,
            clickable: true,
          },
          breakpoints: {
            990: {
              navigation: {
                enabled: true,
                nextEl: `#shopify-section-${this.sid} .swiper-button-next`,
                prevEl: `#shopify-section-${this.sid} .swiper-button-prev`,
              },
            }
          }
        });
      };
    }

    customElements.define('featured-study', FeaturedStudy);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haroutine-amc-performance"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('haroutine-amc-performance')) {
  customElements.define('haroutine-amc-performance', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.tablist = this.querySelector('[data-tablist]');
      if (this.tabs.length > 1 && this.panels.length > 1) {
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.selectView(tab.dataset.tab), options);
          tab.addEventListener('keydown', (event) => {
            const index = this.tabs.indexOf(tab);
            let next;
            const rtl = getComputedStyle(this).direction === 'rtl';
            if (event.key === 'ArrowRight') next = index + (rtl ? -1 : 1);
            if (event.key === 'ArrowLeft') next = index + (rtl ? 1 : -1);
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            const target = this.tabs[(next + this.tabs.length) % this.tabs.length];
            this.selectView(target.dataset.tab, true);
          }, options);
        });
        this.panels.forEach((panel) => {
          const tab = this.tabs.find((item) => item.dataset.tab === panel.dataset.panel);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
          panel.tabIndex = 0;
        });
        this.setAttribute('data-enhanced', '');
        this.selectView(this.dataset.defaultView);
        this.tablist.hidden = false;
      }
      document.addEventListener('shopify:block:select', (event) => {
        if (String(event.detail?.sectionId) !== this.dataset.sectionId) return;
        const block = Array.from(this.querySelectorAll('[data-block-id]')).find(
          (item) => item.dataset.blockId === String(event.detail?.blockId)
        );
        const panel = block?.closest('[data-panel]');
        if (!panel) return;
        this.selectView(panel.dataset.panel);
        // Shopify may scroll before the previously hidden panel is revealed.
        // Only editor selection triggers this scroll; public tab clicks do not.
        cancelAnimationFrame(this.editorFrame);
        this.editorFrame = requestAnimationFrame(() => {
          if (block.isConnected) block.scrollIntoView({ block: 'nearest', behavior: 'auto' });
        });
      }, options);
    }

    selectView(view, focus = false) {
      if (this.tabs.length < 2) return;
      const selected = this.tabs.find((tab) => tab.dataset.tab === view) || this.tabs[0];
      this.tabs.forEach((tab) => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.panel !== selected.dataset.tab;
      });
      if (focus) selected.focus();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      cancelAnimationFrame(this.editorFrame);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haroutine-before-after-v2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('haroutine-before-after')) {
  customElements.define('haroutine-before-after', class extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.initialize()); }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.controller?.abort(); this.controller = null; }
    initialize() {
      if (!this.isConnected || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.panels = [...this.querySelectorAll('[data-hrba-panel]')];
      this.buttons = [...this.querySelectorAll('[data-hrba-select]')];
      if (!this.panels.length) return;
      this.setAttribute('data-enhanced', '');
      const thumbnails = this.querySelector('[data-hrba-thumbnails]');
      if (thumbnails) thumbnails.hidden = false;
      this.querySelectorAll('[data-hrba-range]').forEach(input => {
        input.disabled = false;
        const update = () => {
          input.closest('[data-hrba-comparison]').style.setProperty('--hrba-reveal', input.value + '%');
          input.setAttribute('aria-valuetext', input.value + '% ' + (input.closest('[data-hrba-panel]').querySelector('.hrba__photo-label--before')?.textContent.trim() || 'Before'));
        };
        input.addEventListener('input', update, options); update();
      });
      this.buttons.forEach(button => button.addEventListener('click', () => this.select(button.dataset.hrbaSelect, true), options));
      document.addEventListener('shopify:block:select', event => {
        if (event.detail?.sectionId && event.detail.sectionId !== this.dataset.sectionId) return;
        if (this.panels.some(panel => panel.dataset.blockId === event.detail?.blockId)) this.select(event.detail.blockId, false);
      }, options);
      this.select(this.panels[0].dataset.blockId, false);
    }
    select(id, announce) {
      this.panels.forEach(panel => { panel.hidden = panel.dataset.blockId !== id; });
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.hrbaSelect === id)));
      if (announce) {
        const button = this.buttons.find(item => item.dataset.hrbaSelect === id);
        this.querySelector('[data-hrba-announcement]').textContent = button?.querySelector('.hrba__thumbnail-label')?.textContent || '';
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haroutine-before-after"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('haroutine-before-after')) {
  customElements.define('haroutine-before-after', class extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.initialize()); }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.controller?.abort(); this.controller = null; }
    initialize() {
      if (!this.isConnected || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.panels = [...this.querySelectorAll('[data-hrba-panel]')];
      this.buttons = [...this.querySelectorAll('[data-hrba-select]')];
      if (!this.panels.length) return;
      this.setAttribute('data-enhanced', '');
      const thumbnails = this.querySelector('[data-hrba-thumbnails]');
      if (thumbnails) thumbnails.hidden = false;
      this.querySelectorAll('[data-hrba-range]').forEach(input => {
        input.disabled = false;
        const update = () => {
          input.closest('[data-hrba-comparison]').style.setProperty('--hrba-reveal', input.value + '%');
          input.setAttribute('aria-valuetext', input.value + '% ' + (this.dataset.beforeWord || 'Before'));
        };
        input.addEventListener('input', update, options); update();
      });
      this.buttons.forEach(button => button.addEventListener('click', () => this.select(button.dataset.hrbaSelect, true), options));
      document.addEventListener('shopify:block:select', event => {
        if (event.detail?.sectionId && event.detail.sectionId !== this.dataset.sectionId) return;
        if (this.panels.some(panel => panel.dataset.blockId === event.detail?.blockId)) this.select(event.detail.blockId, false);
      }, options);
      this.select(this.panels[0].dataset.blockId, false);
    }
    select(id, announce) {
      this.panels.forEach(panel => { panel.hidden = panel.dataset.blockId !== id; });
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.hrbaSelect === id)));
      if (announce) {
        const button = this.buttons.find(item => item.dataset.hrbaSelect === id);
        this.querySelector('[data-hrba-announcement]').textContent = button?.querySelector('.hrba__thumbnail-label')?.textContent || '';
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haroutine-bundle-ingredients"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('haroutine-bundle-ingredients')) {
  customElements.define('haroutine-bundle-ingredients', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (this.ready) return;
      this.tabs = Array.from(this.querySelectorAll('[data-product-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-product-panel]'));
      this.tabList = this.querySelector('[data-tabs]');
      if (!this.tabList || this.tabs.length !== 2 || this.panels.length !== 2) return;
      this.ready = true;
      this.activeKey = this.activeKey || this.dataset.initialProduct || 'am';
      this.breakpoint = window.matchMedia('(max-width: 749px)');
      this.panels.forEach(panel => {
        const button = panel.querySelector('[data-more]');
        if (button) {
          button.hidden = false;
          this.setExpanded(panel, button.getAttribute('aria-expanded') === 'true');
        }
      });
      this.onChange = () => this.applyLayout();
      this.onClick = event => {
        const tab = event.target.closest('[data-product-tab]');
        if (tab && this.contains(tab)) {
          this.activeKey = tab.dataset.productTab;
          this.applyLayout();
        }
        const more = event.target.closest('[data-more]');
        if (more && this.contains(more)) this.setExpanded(more.closest('[data-product-panel]'), more.getAttribute('aria-expanded') !== 'true');
      };
      this.onKeydown = event => {
        const tab = event.target.closest('[data-product-tab]');
        if (!tab || !this.tabs.includes(tab) || !this.breakpoint.matches) return;
        let next;
        if (event.key === 'ArrowRight') next = this.tabs[(this.tabs.indexOf(tab) + 1) % this.tabs.length];
        if (event.key === 'ArrowLeft') next = this.tabs[(this.tabs.indexOf(tab) + this.tabs.length - 1) % this.tabs.length];
        if (event.key === 'Home') next = this.tabs[0];
        if (event.key === 'End') next = this.tabs[this.tabs.length - 1];
        if (next) {
          event.preventDefault();
          this.activeKey = next.dataset.productTab;
          this.applyLayout();
          next.focus();
        }
      };
      this.onToggle = event => {
        const detail = event.target;
        if (this.dataset.singleOpen !== 'true' || !detail.matches('[data-ingredient]') || !detail.open) return;
        detail.closest('[data-product-panel]').querySelectorAll('[data-ingredient][open]').forEach(other => { if (other !== detail) other.open = false; });
      };
      this.onBlockSelect = event => {
        const eventSection = event.detail && event.detail.sectionId;
        if (eventSection && eventSection !== this.dataset.sectionId) return;
        const id = event.detail && event.detail.blockId;
        const item = Array.from(this.querySelectorAll('[data-block-id]')).find(block => block.dataset.blockId === id);
        if (!item) return;
        const panel = item.closest('[data-product-panel]');
        this.activeKey = panel.dataset.productPanel;
        this.applyLayout();
        if (item.closest('[data-extra]')) this.setExpanded(panel, true);
        item.open = true;
        if (item.scrollIntoView) item.scrollIntoView({ block: 'nearest', behavior: 'auto' });
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      this.addEventListener('toggle', this.onToggle, true);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      if (this.breakpoint.addEventListener) this.breakpoint.addEventListener('change', this.onChange);
      else this.breakpoint.addListener(this.onChange);
      this.applyLayout();
    }
    setExpanded(panel, expanded) {
      const extra = panel.querySelector('[data-extra]');
      const button = panel.querySelector('[data-more]');
      if (!extra || !button) return;
      extra.hidden = !expanded;
      button.setAttribute('aria-expanded', String(expanded));
      button.querySelector('[data-more-label]').textContent = expanded ? button.dataset.collapseLabel : button.dataset.expandLabel;
    }
    applyLayout() {
      const mobile = this.breakpoint.matches;
      this.tabList.hidden = !mobile;
      this.tabs.forEach(tab => {
        const selected = tab.dataset.productTab === this.activeKey;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach(panel => {
        const key = panel.dataset.productPanel;
        const tab = this.tabs.find(button => button.dataset.productTab === key);
        panel.hidden = mobile && key !== this.activeKey;
        panel.setAttribute('role', mobile ? 'tabpanel' : 'region');
        panel.setAttribute('aria-labelledby', mobile ? tab.id : panel.querySelector('.hbi-product-title').id);
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      if (!this.ready) return;
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('toggle', this.onToggle, true);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      if (this.breakpoint.removeEventListener) this.breakpoint.removeEventListener('change', this.onChange);
      else this.breakpoint.removeListener(this.onChange);
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haroutine-collection-grid"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('haroutine-collection')) return;
  class HaroutineCollection extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.initialize()); }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      if (this.dialog?.open) this.dialog.close();
      this.unlockScroll();
      this.events?.abort();
      this.pendingRequest?.abort();
    }
    initialize() {
      this.events?.abort();
      this.events = new AbortController();
      const signal = this.events.signal;
      this.grid = this.querySelector('[data-hrc-grid]');
      this.cards = [...this.querySelectorAll('[data-hrc-card]')];
      this.tiles = [...this.querySelectorAll('[data-hrc-tile]')];
      this.mobile = matchMedia('(max-width: 989px)');
      this.mobile.addEventListener('change', () => this.arrangeTiles(), {signal});
      this.arrangeTiles();
      this.products = new Map();
      this.cards.forEach(card => {
        const node = card.querySelector('[data-hrc-product]');
        if (!node) return;
        let product;
        try { product = JSON.parse(node.textContent); } catch (_) { return; }
        this.products.set(String(product.id), product);
        const variant = product.variants[0];
        if (!variant) return;
        const picker = card.querySelector('[data-hrc-card-variant]');
        if (picker) { picker.value = String(variant.id); picker.disabled = false; }
        this.updateCard(card, product, variant);
      });
      this.addEventListener('change', event => {
        const picker = event.target.closest('[data-hrc-card-variant]');
        if (!picker) return;
        const card = picker.closest('[data-hrc-card]');
        const product = this.products.get(card.dataset.hrcProductId);
        const variant = product?.variants.find(item => String(item.id) === picker.value);
        if (variant) this.updateCard(card, product, variant);
      }, {signal});
      this.dialog = this.querySelector('[data-hrc-dialog]');
      if (!this.dialog || typeof this.dialog.showModal !== 'function' || this.dataset.subscribeMode === 'product') return;
      this.form = this.dialog.querySelector('[data-hrc-sub-form]');
      this.variantSelect = this.dialog.querySelector('[data-hrc-variant-select]');
      this.planSelect = this.dialog.querySelector('[data-hrc-plan-select]');
      this.submit = this.dialog.querySelector('[data-hrc-submit]');
      this.submitLabel = this.submit.textContent.trim();
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-hrc-subscribe]');
        if (!trigger || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
        const product = this.products.get(trigger.dataset.hrcSubscribe);
        const variant = product?.variants.find(v => String(v.id) === trigger.dataset.hrcVariant);
        if (!variant?.available || !variant.plans.length) return;
        event.preventDefault();
        this.openProduct(product, trigger, variant);
      }, {signal});
      this.dialog.querySelector('[data-hrc-close]').addEventListener('click', () => { if (!this.busy) this.dialog.close(); }, {signal});
      this.dialog.addEventListener('cancel', event => { if (this.busy) event.preventDefault(); }, {signal});
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog || this.busy) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, {signal});
      this.dialog.addEventListener('close', () => {
        this.unlockScroll();
        if (!this.handingOffCart) this.trigger?.focus({preventScroll:true});
        this.handingOffCart = false;
      }, {signal});
      this.dialog.querySelector('[data-hrc-continue]').addEventListener('click', () => this.dialog.close(), {signal});
      this.variantSelect.addEventListener('change', () => { this.variant = this.product.variants.find(v => String(v.id) === this.variantSelect.value); this.renderPlans(); }, {signal});
      this.planSelect.addEventListener('change', () => this.renderPrice(), {signal});
      this.form.addEventListener('submit', event => this.addSubscription(event), {signal});
    }
    arrangeTiles() {
      if (!this.grid || !this.tiles.length) return;
      const fragment = document.createDocumentFragment();
      const count = this.cards.length;
      this.cards.forEach((card, index) => {
        fragment.append(card);
        this.tiles.forEach(tile => {
          const after = Number(this.mobile.matches ? tile.dataset.afterMobile : tile.dataset.afterDesktop) || 1;
          if (Math.min(count, after) === index + 1) fragment.append(tile);
        });
      });
      this.grid.append(fragment);
    }
    unlockScroll() {
      if (this.previousOverflow !== undefined) { document.body.style.overflow = this.previousOverflow; this.previousOverflow = undefined; }
    }
    updateCard(card, product, variant) {
      card.dataset.hrcSelectedVariant = String(variant.id);
      const picker = card.querySelector('[data-hrc-card-variant]');
      if (picker) picker.value = String(variant.id);
      card.querySelector('[data-hrc-card-price]').textContent = variant.priceLabel;
      const compare = card.querySelector('[data-hrc-card-compare]');
      compare.hidden = !product.showComparePrice || !(variant.comparePrice > variant.price);
      card.querySelector('[data-hrc-card-compare-value]').textContent = variant.compareLabel;
      card.querySelector('[data-hrc-stock]').hidden = variant.available;
      let promotion = product.promoMode === 'manual' ? product.promoText : '';
      if (product.promoMode === 'compare' && variant.comparePrice > variant.price) {
        promotion = Math.round((variant.comparePrice - variant.price) * 100 / variant.comparePrice) + '% off';
      }
      const badge = card.querySelector('[data-hrc-promo]');
      badge.textContent = promotion; badge.hidden = !promotion || !variant.available;
      const url = new URL(product.url, location.origin);
      url.searchParams.set('variant', String(variant.id));
      card.querySelectorAll('[data-hrc-card-link]').forEach(link => { link.href = url.toString(); });
      const shopLabel = variant.available ? product.buttonLabel : 'View product';
      card.querySelector('[data-hrc-shop-label]').textContent = shopLabel;
      card.querySelector('[data-hrc-shop]').setAttribute('aria-label', shopLabel + ': ' + product.title + (variant.title === 'Default Title' ? '' : ' — ' + variant.title));
      const subscribe = card.querySelector('[data-hrc-subscribe]');
      const preferred = variant.plans.reduce((best, plan) => !best || plan.price < best.price ? plan : best, null);
      const canSubscribe = Boolean(subscribe && variant.available && preferred);
      if (subscribe) {
        subscribe.hidden = !canSubscribe;
        subscribe.dataset.hrcVariant = String(variant.id);
        if (preferred) url.searchParams.set('selling_plan', String(preferred.id));
        subscribe.href = url.toString();
      }
      card.querySelector('.hrc__card-actions').classList.toggle('hrc__card-actions--two', canSubscribe);
      const image = card.querySelector('.hrc__product-image');
      image.hidden = !variant.image;
      card.querySelector('[data-hrc-image-placeholder]').hidden = Boolean(variant.image);
      if (variant.image) {
        image.srcset = variant.image.srcset;
        image.src = variant.image.src;
        image.alt = variant.image.alt;
      } else {
        image.removeAttribute('srcset'); image.removeAttribute('src');
      }
    }
    openProduct(product, trigger, variant) {
      document.querySelectorAll('haroutine-collection dialog[open]').forEach(d => d.close());
      this.product = product; this.trigger = trigger; this.busy = false;
      this.added = false; this.form.hidden = false;
      this.form.removeAttribute('aria-busy');
      this.variantSelect.disabled = false; this.planSelect.disabled = false;
      this.dialog.querySelector('[data-hrc-success]').hidden = true;
      this.variant = variant;
      this.dialog.querySelector('[data-hrc-title]').textContent = product.title;
      this.dialog.querySelector('.hrc__dialog-image').style.background = product.color;
      this.variantSelect.replaceChildren(...product.variants.map(v => { const option = new Option(v.title + (!v.available ? ' — Sold out' : ''), String(v.id)); option.disabled = !v.available; return option; }));
      this.variantSelect.value = String(this.variant.id);
      this.dialog.querySelector('[data-hrc-variant-field]').hidden = product.variants.length < 2;
      this.clearError(); this.renderPlans();
      this.previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
      this.dialog.showModal();
    }
    renderPlans() {
      const plans = this.variant.plans;
      const card = this.trigger?.closest('[data-hrc-card]');
      if (card) this.updateCard(card, this.product, this.variant);
      const image = this.dialog.querySelector('[data-hrc-image]');
      image.hidden = !this.variant.image;
      if (this.variant.image) { image.src = this.variant.image.small; image.alt = this.variant.image.alt; }
      else image.removeAttribute('src');
      this.dialog.querySelector('[data-hrc-variant-caption]').textContent = this.variant.title === 'Default Title' ? '' : this.variant.title;
      this.form.querySelector('[data-hrc-variant-input]').value = String(this.variant.id);
      this.planSelect.replaceChildren(...plans.map(p => new Option(p.name, String(p.id))));
      const preferred = plans.reduce((best, p) => !best || p.price < best.price ? p : best, null);
      if (preferred) this.planSelect.value = String(preferred.id);
      this.dialog.querySelector('[data-hrc-plan-field]').hidden = plans.length < 2;
      this.clearError(); this.renderPrice();
    }
    frequency(plan) {
      const option = plan.options.find(o => /order frequency and unit/i.test(o.name));
      const match = option?.value?.match(/^(\d+)-(day|week|month|year)s?$/i);
      if (!match) return {label:plan.name, renewal:'Renews automatically according to the selected plan.'};
      const amount = Number(match[1]), unit = match[2].toLowerCase();
      const label = amount === 1 ? 'Every ' + unit : 'Every ' + amount + ' ' + unit + 's';
      return {label, renewal:'Renews automatically ' + label.toLowerCase() + '.'};
    }
    renderPrice() {
      const plan = this.variant.plans.find(p => String(p.id) === this.planSelect.value);
      this.plan = plan;
      const link = this.dialog.querySelector('[data-hrc-product-link]');
      const url = new URL(this.product.url, location.origin); url.searchParams.set('variant', String(this.variant.id));
      if (plan) url.searchParams.set('selling_plan', String(plan.id));
      link.href = url.toString();
      this.form.querySelector('[data-hrc-plan-input]').value = plan ? String(plan.id) : '';
      this.dialog.querySelector('[data-hrc-price-box]').hidden = !plan || !plan.direct;
      this.dialog.querySelector('[data-hrc-perks]')?.toggleAttribute('hidden', !plan || !plan.direct);
      this.submit.hidden = !plan || !plan.direct;
      this.submit.disabled = !plan || !plan.direct || !this.variant.available;
      this.submit.textContent = this.submitLabel;
      link.textContent = !plan ? 'View product options' : !plan.direct ? 'Review this plan on the product page' : 'View full product details';
      link.classList.toggle('hrc__button', !plan || !plan.direct);
      if (!plan) { this.dialog.querySelector('[data-hrc-terms]').textContent = 'A subscription is not available for this option. Choose another option or view the product.'; return; }
      if (!plan.direct) { this.dialog.querySelector('[data-hrc-terms]').textContent = 'Review the full payment and delivery schedule on the product page before subscribing.'; return; }
      const stages = plan.stages, first = stages[0], second = stages[1];
      const initialCount = Number(first?.orders) || 0;
      const changes = Boolean(second && initialCount > 0);
      this.dialog.querySelector('[data-hrc-price]').textContent = first?.label || plan.priceLabel;
      this.dialog.querySelector('[data-hrc-price-period]').textContent = changes ? 'First ' + initialCount + (initialCount === 1 ? ' order' : ' orders') : 'Per delivery';
      this.dialog.querySelector('[data-hrc-next-price]').textContent = changes ? 'Then ' + second.label + ' per order.' : '';
      const frequency = this.frequency(plan);
      this.dialog.querySelector('[data-hrc-frequency]').textContent = frequency.label;
      const amounts = changes ? (first.label + ' per order for the first ' + initialCount + (initialCount === 1 ? ' order, then ' : ' orders, then ') + second.label + ' per order.') : ((first?.label || plan.priceLabel) + ' per delivery.');
      this.dialog.querySelector('[data-hrc-terms]').textContent = amounts + ' ' + frequency.renewal + ' ' + this.dataset.subscriptionTerms;
    }
    clearError() { const error = this.dialog.querySelector('[data-hrc-error]'); error.hidden = true; error.textContent = ''; }
    showAdded(previewFailed = false) {
      this.busy = false; this.added = true;
      this.form.removeAttribute('aria-busy');
      this.form.hidden = true;
      const success = this.dialog.querySelector('[data-hrc-success]');
      success.hidden = false;
      success.querySelector('[data-hrc-success-message]').textContent = previewFailed
        ? 'Your subscription was added to your bag. The cart preview could not be refreshed. Please check your bag before adding again.'
        : 'Your subscription was added to your bag.';
      success.focus({preventScroll:true});
    }
    async openUpdatedCart(drawer, data) {
      const sections = drawer.getSectionsToRender();
      const validSections = payload => sections.every(section => {
        const html = payload?.[section.id];
        if (typeof html !== 'string') return false;
        return new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector || '.shopify-section');
      });
      // A successful add can have null section HTML. Recover by reading only;
      // never resend the add request just because a drawer failed to render.
      if (!validSections(data?.sections)) {
        const url = new URL(location.href);
        url.hash = '';
        url.searchParams.set('sections', sections.map(section => section.id).join(','));
        const response = await fetch(url.toString(), {credentials:'same-origin',headers:{Accept:'application/json'},signal:this.pendingRequest.signal});
        if (!response.ok) throw new Error('Cart preview unavailable');
        data = {...data,sections:await response.json()};
      }
      if (!validSections(data.sections)) throw new Error('Cart preview unavailable');
      this.handingOffCart = true;
      this.dialog.close();
      this.unlockScroll();
      drawer.setActiveElement?.(this.trigger);
      drawer.classList.remove('is-empty');
      drawer.renderContents({...data,id:data.id || data.items?.[0]?.id});
      // Haroutine's shipping bar and payment messaging listen for this event.
      // Use the full cart total, not just the value of the newly added item.
      try {
        const response = await fetch(this.dataset.cartUrl + '.js', {credentials:'same-origin',headers:{Accept:'application/json'},signal:this.pendingRequest.signal});
        if (response.ok) {
          const cart = await response.json();
          if (typeof cart.total_price === 'number') document.dispatchEvent(new CustomEvent('haroutine-cart-updated', {bubbles:true,detail:cart}));
        }
      } catch (_) { /* The item and server-rendered cart are already updated. */ }
    }
    async addSubscription(event) {
      event.preventDefault();
      if (this.busy || this.added || !this.variant?.available || !this.plan?.direct) return;
      this.busy = true; this.clearError(); this.submit.disabled = true; this.submit.textContent = 'Adding…';
      this.variantSelect.disabled = true; this.planSelect.disabled = true;
      this.form.setAttribute('aria-busy','true');
      this.pendingRequest = new AbortController();
      const drawer = document.querySelector('cart-drawer');
      const canRenderDrawer = typeof drawer?.getSectionsToRender === 'function' && typeof drawer?.renderContents === 'function';
      let data;
      try {
        const request = {items:[{id:this.variant.id,quantity:1,selling_plan:this.plan.id}]};
        if (canRenderDrawer) {
          request.sections = drawer.getSectionsToRender().map(section => section.id);
          request.sections_url = location.pathname;
        }
        const response = await fetch(this.dataset.cartAddUrl, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(request),signal:this.pendingRequest.signal});
        try { data = await response.json(); } catch (_) { data = null; }
        if (!response.ok || data?.status >= 400) throw new Error(typeof data?.description === 'string' ? data.description : 'This option could not be added. Please review the product and try again.');
      } catch (error) {
        if (!this.isConnected || error.name === 'AbortError') return;
        const message = this.dialog.querySelector('[data-hrc-error]');
        message.textContent = error.message || 'We could not confirm the cart update. Check your bag before trying again.'; message.hidden = false;
        this.busy = false; this.submit.disabled = false; this.submit.textContent = this.submitLabel;
        this.variantSelect.disabled = false; this.planSelect.disabled = false;
        this.form.removeAttribute('aria-busy');
        return;
      }
      if (!this.isConnected) return;
      this.showAdded();
      if (canRenderDrawer) {
        try { await this.openUpdatedCart(drawer, data); }
        catch (error) {
          if (!this.isConnected || error.name === 'AbortError') return;
          if (!this.dialog.open) {
            this.previousOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
            this.dialog.showModal();
          }
          this.showAdded(true);
        }
      }
    }
  }
  customElements.define('haroutine-collection', HaroutineCollection);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haroutine-ingredient-explorer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'haroutine-ingredient-explorer';
    if (!('customElements' in window) || customElements.get(elementName)) return;

    class HaroutineIngredientExplorer extends HTMLElement {
      constructor() {
        super();
        this.handleToggle = this.handleToggle.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
      }

      connectedCallback() {
        this.addEventListener('toggle', this.handleToggle, true);
        this.addEventListener('shopify:block:select', this.handleBlockSelect);
      }

      disconnectedCallback() {
        this.removeEventListener('toggle', this.handleToggle, true);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }

      closeOthers(current) {
        if (this.dataset.singleOpen !== 'true') return;
        this.querySelectorAll('details.hi-item[open]').forEach((item) => {
          if (item !== current) item.open = false;
        });
      }

      handleToggle(event) {
        const item = event.target;
        if (!(item instanceof HTMLDetailsElement) || !item.matches('.hi-item') || !item.open) return;
        this.closeOthers(item);
      }

      handleBlockSelect(event) {
        const blockId = event.detail && event.detail.blockId;
        const item = Array.from(this.querySelectorAll('details.hi-item')).find((node) => node.dataset.blockId === blockId);
        if (!item) return;
        this.closeOthers(item);
        item.open = true;
      }
    }

    customElements.define(elementName, HaroutineIngredientExplorer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haroutine-liposomal-proof"] && !Shopify.designMode) return;
  try {
    
  if ('customElements' in window && !customElements.get('haroutine-liposomal-section')) {
    customElements.define('haroutine-liposomal-section', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.setupVideo());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        if (this.observer) this.observer.disconnect();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
        if (this.motion && this.onMotion) this.motion.removeEventListener('change', this.onMotion);
        if (this.video && this.onInteraction) {
          this.video.removeEventListener('pointerdown', this.onInteraction);
          this.video.removeEventListener('keydown', this.onInteraction);
        }
        if (this.video && this.autoPlaying) this.video.pause();
        this.autoPlaying = false;
      }
      setupVideo() {
        this.video = this.querySelector('video');
        if (!this.video || this.dataset.autoplay !== 'true' || this.dataset.designMode === 'true') return;
        // Without these browser features, native click-to-play remains available.
        if (!('IntersectionObserver' in window) || !window.matchMedia) return;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.inView = false;
        this.userInteracted = false;
        this.autoPlaying = false;
        this.onInteraction = () => { this.userInteracted = true; this.autoPlaying = false; };
        this.onVisibility = () => this.syncPlayback();
        this.onMotion = () => this.syncPlayback();
        this.video.addEventListener('pointerdown', this.onInteraction);
        this.video.addEventListener('keydown', this.onInteraction);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.motion.addEventListener('change', this.onMotion);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .25);
          this.syncPlayback();
        }, { threshold: [0, .25] });
        this.observer.observe(this.video);
      }
      syncPlayback() {
        if (!this.isConnected || this.userInteracted || !this.video) return;
        const canPlay = this.inView && !this.motion.matches && document.visibilityState !== 'hidden';
        if (canPlay && !this.autoPlaying) {
          this.video.muted = true;
          this.video.defaultMuted = true;
          this.autoPlaying = true;
          const attempt = this.video.play();
          if (attempt && typeof attempt.catch === 'function') {
            attempt.catch(() => { this.autoPlaying = false; });
          }
        } else if (!canPlay && this.autoPlaying) {
          this.video.pause();
          this.autoPlaying = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haroutine-main-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('haroutine-main-product')) {
  customElements.define('haroutine-main-product', class extends HTMLElement {
    connectedCallback() { this.initFrame = requestAnimationFrame(() => this.init()); }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame); cancelAnimationFrame(this.layoutFrame);
      clearInterval(this.welcomeKitTimer);
      this.controller?.abort(); this.resizeObserver?.disconnect(); this.rebuyObserver?.disconnect();
      this.controller = null;
    }
    init() {
      if (!this.isConnected || this.controller) return;
      this.controller = new AbortController(); const options = {signal:this.controller.signal};
      try { this.data = JSON.parse(this.querySelector('[data-hrp-data]').value); } catch (_) { return; }
      this.form = this.querySelector('form.hrp__form');
      this.info = this.querySelector('[data-hrp-info]');
      this.gallery = this.querySelector('[data-hrp-gallery]');
      this.media = [...this.querySelectorAll('[data-hrp-media]')];
      this.variant = this.data.variants.find(v => String(v.id) === String(this.data.selected)) || this.data.variants[0];
      this.setAttribute('data-enhanced', '');
      this.querySelectorAll('[data-hrp-variant]').forEach(link => link.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const variant = this.data.variants.find(v => String(v.id) === link.dataset.hrpVariant);
        if (!variant) return;
        event.preventDefault(); this.selectVariant(variant, true);
      }, options));
      if (this.form) {
        this.form.addEventListener('submit', event => this.addToCart(event), options);
        this.variantInput = this.form.querySelector('[data-hrp-variant-input]');
        this.quantity = this.form.elements.namedItem('quantity');
        this.addButton = this.querySelector('[data-hrp-add]');
        this.planInput = this.form.querySelector('[data-hrp-plan]');
        this.nativePlans = this.form.querySelector('[data-hrp-native]');
        const requestedPlan = new URL(location.href).searchParams.get('selling_plan');
        if (this.nativePlans) this.renderPlans(requestedPlan || (this.data.requiresPlan ? String(this.variant.plans[0]?.id || '') : ''));
        this.querySelector('[data-hrp-minus]')?.addEventListener('click', () => { this.quantity.stepDown();this.quantity.dispatchEvent(new Event('change',{bubbles:true})); }, options);
        this.querySelector('[data-hrp-plus]')?.addEventListener('click', () => { this.quantity.stepUp();this.quantity.dispatchEvent(new Event('change',{bubbles:true})); }, options);
        this.quantity.addEventListener('change', () => this.updateQuantityButtons(), options);
        this.planInput?.addEventListener('change', () => this.syncNativePlan(), options);
        this.nativePlans?.addEventListener('change', event => {
          if (event.target.matches('[data-hrp-plan-choice]')) { this.planInput.value=event.target.value;this.planInput.dispatchEvent(new Event('change',{bubbles:true})); }
        }, options);
        this.updateButton(); this.updateQuantityButtons();
        this.welcomeKit = this.form.querySelector('[data-hrp-welcome-kit]');
        if (this.welcomeKit) {
          this.addEventListener('change', () => this.syncWelcomeKit(), options);
          this.syncWelcomeKit();
          // Recharge can set a hidden input's value without a DOM event.
          // Read only: never create or alter the app's selling_plan input.
          this.welcomeKitTimer = setInterval(() => this.syncWelcomeKit(), 500);
        }
      }
      this.gallery?.addEventListener('scroll', () => this.queueLayout(), {...options,passive:true});
      this.querySelector('[data-hrp-prev]')?.addEventListener('click', () => this.stepGallery(-1), options);
      this.querySelector('[data-hrp-next]')?.addEventListener('click', () => this.stepGallery(1), options);
      this.gallery?.addEventListener('keydown', event => {
        if (event.target !== this.gallery || !matchMedia('(max-width:989px)').matches) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault();this.stepGallery(event.key==='ArrowLeft'?-1:1); }
      }, options);
      this.dialog = this.querySelector('[data-hrp-dialog]');
      this.querySelectorAll('[data-hrp-zoom]').forEach(link => link.addEventListener('click', event => {
        if (!this.dialog?.showModal || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); const image=this.dialog.querySelector('[data-hrp-large]');
        image.src=link.href;image.alt=link.querySelector('img')?.alt || '';this.dialog.showModal();
      }, options));
      this.querySelector('[data-hrp-close]')?.addEventListener('click',()=>this.dialog.close(),options);
      this.dialog?.addEventListener('click', event => { if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();} },options);
      if ('ResizeObserver' in window) { this.resizeObserver=new ResizeObserver(()=>this.queueLayout());this.resizeObserver.observe(this.info);this.resizeObserver.observe(this.gallery); }
      window.addEventListener('resize',()=>this.queueLayout(),{...options,passive:true});
      this.rebuyShells=[...this.querySelectorAll('[data-hrp-rebuy-shell]')];
      this.rebuyObserver=new MutationObserver(()=>this.revealRebuy());
      this.rebuyShells.forEach(shell=>this.rebuyObserver.observe(shell,{childList:true,subtree:true}));
      document.addEventListener('rebuy.ready',()=>this.revealRebuy(),options);
      document.addEventListener('rebuy.add',event=>this.onRebuyAdded(event),options);
      document.addEventListener('shopify:block:select',event=>{
        if(event.detail?.sectionId!==this.dataset.sectionId)return;
        const media=this.media.find(item=>item.dataset.blockId===event.detail.blockId);
        if(media){media.hidden=false;this.updateGalleryControls();if(matchMedia('(max-width:989px)').matches)this.gallery.scrollTo({left:media.offsetLeft-this.media[0].offsetLeft,behavior:'auto'});}
      },options);
      window.addEventListener('popstate',()=>{const id=new URL(location.href).searchParams.get('variant');const variant=this.data.variants.find(v=>String(v.id)===id);if(variant)this.selectVariant(variant,false);},options);
      this.filterGallery();this.revealRebuy();this.queueLayout();
    }
    syncWelcomeKit() {
      if (!this.welcomeKit || !this.form) return;
      const widget = this.querySelector('recharge-subscription-widget');
      const formData = new FormData(this.form);
      const plans = [...new Set(formData.getAll('selling_plan').map(String).filter(Boolean))];
      // An empty, present field is an explicit one-time selection.
      if (!formData.has('selling_plan') && widget?.sellingPlanId) plans.push(String(widget.sellingPlanId));
      const widgetMatchesVariant = !widget?.variantId || String(widget.variantId) === String(this.variant.id);
      const subscribed = widgetMatchesVariant && plans.length === 1 && this.variant.plans.some(plan => String(plan.id) === plans[0]);
      if (this.welcomeKit.hidden === subscribed) this.welcomeKit.hidden = !subscribed;
    }
    selectVariant(variant, updateUrl) {
      if (this.busy) return;
      const previousPlan=this.planInput?.value ?? null;
      this.variant=variant;
      this.querySelectorAll('[data-hrp-variant]').forEach(link=>link.setAttribute('aria-current',String(link.dataset.hrpVariant===String(variant.id))));
      if(this.variantInput){
        this.variantInput.value=variant.id;
        this.variantInput.setAttribute('value',variant.id);
        if(this.nativePlans)this.renderPlans(previousPlan);
        this.quantity.min=variant.min;this.quantity.step=variant.increment;
        if(variant.max!==null)this.quantity.max=variant.max;else this.quantity.removeAttribute('max');
        let quantity=Number(this.quantity.value)||variant.min;
        quantity=Math.max(variant.min,quantity);
        quantity=variant.min+Math.floor((quantity-variant.min)/variant.increment)*variant.increment;
        if(variant.max!==null)quantity=Math.min(quantity,variant.max);
        this.quantity.value=quantity;
        this.variantInput.dispatchEvent(new Event('change',{bubbles:true}));
        this.updateButton();this.updateQuantityButtons();
        this.status('',false);
      }
      if(updateUrl){const url=new URL(location.href);url.searchParams.set('variant',variant.id);if(this.nativePlans){if(this.planInput.value)url.searchParams.set('selling_plan',this.planInput.value);else url.searchParams.delete('selling_plan');}history.replaceState(history.state,'',url);}
      this.filterGallery();
      this.syncWelcomeKit();
      this.dispatchEvent(new CustomEvent('haroutine:variant-change',{bubbles:true,detail:{variant,sectionId:this.dataset.sectionId,form:this.form}}));
    }
    filterGallery() {
      let visible=0;
      const group=this.variant?.group || '',filter=this.dataset.filterMedia==='true',limit=Number(this.dataset.galleryLimit)||6;
      this.media.forEach(item=>{
        const matches=!filter||!group||!item.dataset.mediaGroup||item.dataset.mediaGroup===group;
        const show=matches&&++visible<=limit;
        if(!show&&!item.hidden)this.pauseMedia(item);
        item.hidden=!show;
      });
      if(this.gallery)this.gallery.scrollLeft=0;
      this.updateGalleryControls();
    }
    pauseMedia(item) {
      item.querySelectorAll('video').forEach(v=>v.pause());
      item.querySelectorAll('iframe').forEach(frame=>{try{const url=new URL(frame.src);if(/youtube/.test(url.hostname))frame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}),url.origin);else if(url.hostname==='player.vimeo.com')frame.contentWindow?.postMessage(JSON.stringify({method:'pause'}),url.origin);}catch(_){}});
    }
    visibleMedia(){return this.media.filter(item=>!item.hidden);}
    currentMediaIndex(){const items=this.visibleMedia();if(!items.length)return 0;const left=this.gallery.getBoundingClientRect().left;let best=0,distance=Infinity;items.forEach((item,i)=>{const delta=Math.abs(item.getBoundingClientRect().left-left);if(delta<distance){best=i;distance=delta;}});return best;}
    stepGallery(step){const items=this.visibleMedia();const i=Math.max(0,Math.min(items.length-1,this.currentMediaIndex()+step));if(!items[i])return;this.gallery.scrollBy({left:items[i].getBoundingClientRect().left-this.gallery.getBoundingClientRect().left,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});}
    updateGalleryControls(){const items=this.visibleMedia(),i=this.currentMediaIndex();const controls=this.querySelector('[data-hrp-gallery-controls]');if(controls)controls.hidden=items.length<2;const counter=this.querySelector('[data-hrp-counter]');if(counter)counter.textContent=(items.length?i+1:0)+' / '+items.length;const prev=this.querySelector('[data-hrp-prev]'),next=this.querySelector('[data-hrp-next]');if(prev)prev.disabled=i===0;if(next)next.disabled=i>=items.length-1;}
    queueLayout(){cancelAnimationFrame(this.layoutFrame);this.layoutFrame=requestAnimationFrame(()=>{if(!this.isConnected)return;const top=parseFloat(getComputedStyle(this).getPropertyValue('--hrp-sticky-offset'))||80;const offset=Math.min(top,innerHeight-this.info.offsetHeight-24);this.style.setProperty('--hrp-sticky-top',offset+'px');this.updateGalleryControls();});}
    renderPlans(requested) {
      const plans=this.variant.plans,select=this.planInput;
      select.replaceChildren();
      if(!this.data.requiresPlan)select.add(new Option(this.data.oneTimeLabel+' — '+this.variant.formattedPrice,''));
      plans.forEach(p=>select.add(new Option(p.name+' — '+p.formattedPrice,String(p.id))));
      let value=requested;
      if(value===null)value=this.data.requiresPlan?String(plans[0]?.id||''):'';
      if(value&&!plans.some(p=>String(p.id)===String(value)))value=null;
      if(this.data.requiresPlan&&!value)value=null;
      if(value===null)select.selectedIndex=-1;else select.value=value;
      const cards=this.nativePlans.querySelector('[data-hrp-plan-cards]');cards.replaceChildren();
      const choices=[...(!this.data.requiresPlan?[{id:'',name:this.data.oneTimeLabel,price:this.variant.formattedPrice}]:[]),...plans.map(p=>({id:String(p.id),name:this.data.subscriptionLabel,price:p.formattedPrice,detail:p.name}))];
      choices.forEach(choice=>{const label=document.createElement('label');label.className='hrp__plan-card';const row=document.createElement('div'),main=document.createElement('span'),input=document.createElement('input');input.type='radio';input.name='hrp-plan-choice-'+this.dataset.sectionId;input.value=choice.id;input.dataset.hrpPlanChoice='';input.checked=value!==null&&choice.id===String(value);const title=document.createElement('strong');title.textContent=choice.name;main.append(input,title);const price=document.createElement('span');price.className='hrp__plan-price';price.textContent=choice.price;row.append(main,price);label.append(row);if(choice.detail){const detail=document.createElement('span');detail.className='hrp__plan-name';detail.textContent=choice.detail;label.append(detail);}cards.append(label);});
      this.nativePlans.dataset.enhanced='';select.tabIndex=-1;select.setAttribute('aria-hidden','true');cards.setAttribute('role','radiogroup');cards.setAttribute('aria-label',this.data.planHeading);cards.hidden=false;this.syncNativePlan();
    }
    syncNativePlan() {
      const value=this.planInput.value,selected=this.variant.plans.find(p=>String(p.id)===value);
      this.nativePlans.querySelectorAll('[data-hrp-plan-choice]').forEach(radio=>radio.checked=this.planInput.selectedIndex>=0&&radio.value===value);
      const detail=this.nativePlans.querySelector('[data-hrp-plan-detail]');detail.replaceChildren();
      if(selected){
        const lines=[this.data.initialChargeLabel+' '+selected.formattedPrice];
        const first=selected.priceAdjustments[0],second=selected.priceAdjustments[1];
        if(second){lines.push(this.data.nextChargeLabel+' '+second.price+(first?.orderCount?' (after '+first.orderCount+' orders)':''));}
        if(selected.perDelivery!==selected.formattedPrice)lines.push('Per delivery: '+selected.perDelivery);
        if(selected.description)lines.push(selected.description);
        lines.push(this.data.billingLabel);detail.textContent=lines.filter(Boolean).join(' · ');
      } else if(this.planInput.selectedIndex<0)detail.textContent=this.dataset.planError;
      this.updateButton();
      this.syncWelcomeKit();
    }
    updateButton(){if(!this.addButton)return;const invalidNative=this.planInput&&this.planInput.selectedIndex<0;this.addButton.disabled=this.busy||!this.variant.available||Boolean(invalidNative);this.querySelector('[data-hrp-add-text]').textContent=this.busy?this.dataset.addingLabel:!this.variant.available?this.dataset.soldLabel:this.dataset.addLabel;this.addButton.setAttribute('aria-busy',String(Boolean(this.busy)));}
    updateQuantityButtons(){const minus=this.querySelector('[data-hrp-minus]'),plus=this.querySelector('[data-hrp-plus]');if(minus)minus.disabled=Number(this.quantity.value)<=Number(this.quantity.min);if(plus)plus.disabled=this.quantity.max!==''&&Number(this.quantity.value)>=Number(this.quantity.max);}
    status(message, showLink=false){const node=this.querySelector('[data-hrp-status]');if(node){node.hidden=!message;node.textContent=message;}const link=this.querySelector('[data-hrp-cart-link]');if(link)link.hidden=!showLink;}
    cart(){const cart=document.querySelector('cart-drawer')||document.querySelector('cart-notification');return cart&&typeof cart.getSectionsToRender==='function'&&typeof cart.renderContents==='function'?cart:null;}
    sectionKeys(cart){return cart?cart.getSectionsToRender().map(s=>s.section||s.id).filter(Boolean).slice(0,5):[];}
    renderCart(cart,response){const keys=this.sectionKeys(cart);if(!keys.length||!keys.every(key=>typeof response.sections?.[key]==='string'))return false;try{cart.classList.remove('is-empty');cart.setActiveElement?.(this.addButton);cart.renderContents(response);return true;}catch(_){return false;}}
    async addToCart(event) {
      if(event.defaultPrevented)return;
      event.preventDefault();if(this.busy||!this.variant?.available)return;
      if(!this.form.reportValidity())return;
      const formData=new FormData(this.form),ids=formData.getAll('id'),plans=formData.getAll('selling_plan').map(String).filter(Boolean);
      // Never drop an app's plan/properties or guess which duplicated plan is intended.
      const distinctPlans=[...new Set(plans)];
      if(this.data.planMode==='recharge'&&this.variant.plans.length&&!formData.has('selling_plan')){this.status(this.dataset.planError);return;}
      if(formData.getAll('selling_plan').length>1){this.status(this.dataset.planError);return;}
      const rechargeWidget=this.querySelector('recharge-subscription-widget');
      if(this.data.planMode==='recharge'&&rechargeWidget){
        if(rechargeWidget.variantId&&String(rechargeWidget.variantId)!==String(this.variant.id)){this.status(this.dataset.planError);return;}
        if(rechargeWidget.sellingPlanId&&String(rechargeWidget.sellingPlanId)!==distinctPlans[0]){this.status(this.dataset.planError);return;}
      }
      if(ids.length!==1||String(ids[0])!==String(this.variant.id)){this.status('Please refresh this product page before adding to your bag.');return;}
      if(distinctPlans.length>1||(distinctPlans.length===1&&!this.variant.plans.some(p=>String(p.id)===distinctPlans[0]))||(this.data.requiresPlan&&!distinctPlans.length)){this.status(this.dataset.planError);return;}
      if(distinctPlans.length)formData.set('selling_plan',distinctPlans[0]);else formData.delete('selling_plan');
      formData.delete('return_to');
      // These controls are UI only, not Shopify line-item fields.
      formData.delete('hrp-plan-choice-'+this.dataset.sectionId);
      const quantity=Number(formData.get('quantity'));
      if(!Number.isInteger(quantity)||quantity<this.variant.min||(quantity-this.variant.min)%this.variant.increment!==0||(this.variant.max!==null&&quantity>this.variant.max)){this.status('Please select a valid quantity.');return;}
      const cart=this.dataset.cartMode==='drawer'?this.cart():null;
      if(cart){formData.set('sections',this.sectionKeys(cart).join(','));formData.set('sections_url',location.pathname);}
      this.busy=true;this.status('');this.updateButton();let added=false;
      try {
        const url=this.dataset.addUrl.replace(/\.js$/,'')+'.js';
        const response=await fetch(url,{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:formData,credentials:'same-origin'});
        const result=await response.json();
        if(!response.ok||result.status){this.status(typeof result.description==='string'?result.description:this.dataset.errorLabel);return;}
        added=true;this.status(this.dataset.addedLabel,true);
        this.dispatchEvent(new CustomEvent('haroutine:cart-added',{bubbles:true,detail:{response:result,variantId:this.variant.id,form:this.form}}));
        if(this.dataset.cartMode==='page'){location.assign(this.dataset.cartUrl);return;}
        if(cart&&!this.renderCart(cart,result))this.status(this.dataset.addedLabel,true);
      } catch(_) {this.status(added?this.dataset.addedLabel:this.dataset.errorLabel,true);}
      finally {this.busy=false;this.updateButton();}
    }
    revealRebuy(){this.rebuyShells.forEach(shell=>{const ready=Boolean(shell.querySelector('.rebuy-product-block:not([v-for])'));if(ready)shell.classList.remove('hrp__rebuy--pending');else if(this.dataset.editor!=='true')shell.classList.add('hrp__rebuy--pending');});this.queueLayout();}
    async onRebuyAdded(event){
      const id=String(event.detail?.widget?.id??'');
      if(!id||!this.rebuyShells.some(shell=>shell.dataset.widgetId===id))return;
      this.status(this.dataset.addedLabel,true);
      if(this.dataset.rebuyCart!=='true')return;
      const cart=this.cart();if(!cart)return;
      // Rebuy already added the item. This is a read-only drawer refresh, never another add.
      try{const url=new URL(this.dataset.cartUrl,location.origin);url.searchParams.set('sections',this.sectionKeys(cart).join(','));const response=await fetch(url,{headers:{Accept:'application/json'},credentials:'same-origin'});if(!response.ok)return;const sections=await response.json();this.renderCart(cart,{sections,id:event.detail?.product?.id});}catch(_){}
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haroutine-product-proof"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('haroutine-product-proof')) return;

    class HaroutineProductProof extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        const options = { signal: this.events.signal };
        this.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-hpp-open]');
          if (trigger && this.contains(trigger)) {
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            try {
              this.dialog.showModal();
              this.trigger = trigger;
              this.lockScroll();
              event.preventDefault();
            } catch (_) {
              // The real image link remains available if a browser cannot open a modal.
            }
          }
          if (event.target.closest('[data-hpp-close]')) this.dialog.close();
        }, options);
        this.dialog.addEventListener('pointerdown', (event) => {
          this.startedOnBackdrop = this.isBackdrop(event);
        }, options);
        this.dialog.addEventListener('click', (event) => {
          if (this.startedOnBackdrop && this.isBackdrop(event)) this.dialog.close();
          this.startedOnBackdrop = false;
        }, options);
        this.dialog.addEventListener('keydown', (event) => {
          if (event.key !== 'Tab') return;
          const targets = Array.from(this.dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'))
            .filter((element) => element.getClientRects().length > 0);
          const first = targets[0];
          const last = targets[targets.length - 1];
          if (!first) return;
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }, options);
        this.dialog.addEventListener('close', () => {
          this.unlockScroll();
          if (this.trigger && this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
        }, options);
      }

      isBackdrop(event) {
        if (event.target !== this.dialog) return false;
        const rect = this.dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      }

      lockScroll() {
        const state = HaroutineProductProof.scroll;
        if (state.owners.has(this)) return;
        if (state.owners.size === 0) {
          state.styles = [
            [document.documentElement, 'overflow'],
            [document.body, 'overflow'],
            [document.body, 'padding-right']
          ].map(([element, property]) => [element, property, element.style.getPropertyValue(property), element.style.getPropertyPriority(property)]);
          const gutter = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
          const padding = parseFloat(window.getComputedStyle(document.body).paddingRight) || 0;
          document.documentElement.style.setProperty('overflow', 'hidden', 'important');
          document.body.style.setProperty('overflow', 'hidden', 'important');
          if (gutter) document.body.style.setProperty('padding-right', `${padding + gutter}px`, 'important');
        }
        state.owners.add(this);
      }

      unlockScroll() {
        const state = HaroutineProductProof.scroll;
        if (!state.owners.delete(this) || state.owners.size) return;
        (state.styles || []).forEach(([element, property, value, priority]) => {
          if (value) element.style.setProperty(property, value, priority);
          else element.style.removeProperty(property);
        });
        state.styles = null;
      }

      disconnectedCallback() {
        if (this.events) this.events.abort();
        if (this.dialog && this.dialog.open) this.dialog.close();
        this.unlockScroll();
        this.events = null;
        this.trigger = null;
      }
    }
    HaroutineProductProof.scroll = { owners: new Set(), styles: null };
    customElements.define('haroutine-product-proof', HaroutineProductProof);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haroutine-real-results"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('haroutine-customer-stories')){
 customElements.define('haroutine-customer-stories',class extends HTMLElement{
  connectedCallback(){this.frame=requestAnimationFrame(()=>this.init());}
  disconnectedCallback(){cancelAnimationFrame(this.frame);this.controller?.abort();this.controller=null;}
  init(){
   if(!this.isConnected||this.controller)return;
   this.controller=new AbortController();const opts={signal:this.controller.signal};
   this.slides=[...this.querySelectorAll('[data-hrs-slide]')];this.pickers=[...this.querySelectorAll('[data-hrs-picker]')];
   if(!this.slides.length)return;
   this.index=0;this.setAttribute('data-enhanced','');
   this.querySelector('[data-hrs-pickers]').hidden=this.slides.length<2;
   this.querySelector('[data-hrs-navigation]').hidden=this.slides.length<2;
   this.pickers.forEach((b,i)=>b.addEventListener('click',()=>this.select(i),opts));
   this.querySelector('[data-hrs-prev]').addEventListener('click',()=>this.select(this.index-1),opts);
   this.querySelector('[data-hrs-next]').addEventListener('click',()=>this.select(this.index+1),opts);
   this.addEventListener('keydown',e=>{if(!e.target.closest('[data-hrs-picker],[data-hrs-prev],[data-hrs-next]'))return;if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.select(this.index+(e.key==='ArrowLeft'?-1:1));}},opts);
   this.querySelectorAll('[data-hrs-swipe]').forEach(el=>{
    el.addEventListener('pointerdown',e=>{if(e.pointerType==='touch')this.swipe={x:e.clientX,y:e.clientY,id:e.pointerId};},opts);
    el.addEventListener('pointercancel',()=>this.swipe=null,opts);
    el.addEventListener('pointerup',e=>{const s=this.swipe;this.swipe=null;if(!s||s.id!==e.pointerId)return;const dx=e.clientX-s.x,dy=e.clientY-s.y;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.4)this.select(this.index+(dx<0?1:-1));},opts);
   });
   document.addEventListener('shopify:block:select',e=>{if(e.detail?.sectionId!==this.dataset.sectionId)return;const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail.blockId);if(i>=0)this.select(i);},opts);
   this.select(0,false);
  }
  select(i,scroll=true){
   this.index=(i+this.slides.length)%this.slides.length;
   this.slides.forEach((s,j)=>s.hidden=j!==this.index);
   this.pickers.forEach((b,j)=>b.setAttribute('aria-pressed',String(j===this.index)));
   this.querySelector('[data-hrs-count]').textContent=(this.index+1)+' / '+this.slides.length;
   if(scroll){const picker=this.pickers[this.index],row=this.querySelector('[data-hrs-pickers]');if(picker&&row.scrollWidth>row.clientWidth){const delta=picker.getBoundingClientRect().left-row.getBoundingClientRect().left;row.scrollBy({left:delta,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});}}
  }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haroutine-recharge-cart"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('haroutine-recharge-cart')) {
  customElements.define('haroutine-recharge-cart', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.queue = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.discover(); });
      };
      this.documentObserver = new MutationObserver(this.queue);
      this.documentObserver.observe(document.body, { childList: true, subtree: true });
      // Attaching a shadow root does not itself produce a document mutation.
      this.discoveryTimer = setInterval(this.queue, 1500);
      this.discover();
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      this.documentObserver?.disconnect(); this.rootObserver?.disconnect();
      clearInterval(this.discoveryTimer); cancelAnimationFrame(this.frame); this.frame = 0;
      this.releaseRoot();
    }
    releaseRoot() {
      this.rootObserver?.disconnect(); this.rootObserver = null;
      if (this.cartRoot) {
        this.cartRoot.removeEventListener('change', this.queue);
        this.cartRoot.querySelector('[data-haroutine-recharge-style]')?.remove();
        this.cartRoot.querySelector('[data-haroutine-recharge-notice]')?.remove();
        this.cartRoot.querySelector('#CartSheet')?.removeAttribute('data-hrc-styled');
      }
      this.cartRoot = null;
    }
    discover() {
      if (!this.isConnected) return;
      // Exact open-shadow host observed on Haroutine. Do not style unrelated carts.
      const host = document.getElementById('recharge-storefront-experiences__cart-drawer');
      const root = host?.shadowRoot;
      if (root !== this.cartRoot) {
        this.releaseRoot();
        if (!root) return;
        this.cartRoot = root;
        this.rootObserver = new MutationObserver(this.queue);
        this.rootObserver.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'selected', 'data-state'] });
        root.addEventListener('change', this.queue);
      }
      if (!root) return;
      if (!root.querySelector('[data-haroutine-recharge-style]')) {
        const style = this.querySelector('[data-hrc-styles]')?.content.querySelector('style');
        if (style) root.append(style.cloneNode(true));
      }
      const sheet = root.querySelector('#CartSheet');
      if (!sheet) return;
      if (!sheet.hasAttribute('data-hrc-styled')) sheet.setAttribute('data-hrc-styled', '');
      this.syncNotice(sheet);
    }
    syncNotice(sheet) {
      const list = sheet.querySelector('#cart-drawer section[role="list"]');
      let notice = sheet.querySelector('[data-haroutine-recharge-notice]');
      if (this.dataset.showNotice !== 'true' || !list) { notice?.remove(); return; }
      // Recharge's native frequency select is the observed subscription state.
      // This is policy messaging, never a claim that the customer qualifies.
      const subscribed = [...list.querySelectorAll('select[name="selling_plan"]')].some(select =>
        !select.disabled && /^\d+$/.test(String(select.value)) && [...select.options].some(option => option.value === select.value)
      );
      if (!notice && subscribed) {
        const template = this.querySelector('[data-hrc-notice]')?.content.firstElementChild;
        if (!template) return;
        notice = template.cloneNode(true);
        list.after(notice);
      }
      if (notice && notice.hidden === subscribed) notice.hidden = !subscribed;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haroutine-science-tabs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('haroutine-science-tabs')) {
  customElements.define('haroutine-science-tabs', class extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.initialize()); }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame); cancelAnimationFrame(this.chartFrame);
      this.controller?.abort(); this.observer?.disconnect(); this.visibilityObserver?.disconnect();
      this.models?.forEach(model => model.animations?.forEach(animation => animation.cancel()));
      this.controller = null;
    }
    initialize() {
      if (!this.isConnected || this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.motionPreference.addEventListener('change', event => {
        if (event.matches) this.models.forEach(model => model.animations?.forEach(animation => animation.finish()));
      }, options);
      this.tabs = [...this.querySelectorAll('[data-hst-tab]')];
      this.panels = [...this.querySelectorAll('[data-hst-panel]')];
      this.models = []; this.widths = new WeakMap();
      if (!this.tabs.length) return;
      this.setAttribute('data-enhanced', '');
      this.querySelector('[data-hst-tabs]').hidden = this.tabs.length < 2;
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.show(tab.dataset.hstTab), options);
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault(); this.show(this.tabs[next].dataset.hstTab); this.tabs[next].focus();
        }, options);
      });
      this.querySelectorAll('[data-hst-people]').forEach(grid => {
        const count = Number(grid.dataset.count), total = Number(grid.dataset.total);
        if (!Number.isInteger(count) || !Number.isInteger(total) || total < 1 || count < 0 || count > total) return;
        grid.replaceChildren(); grid.hidden = false;
        if (total > 200) {
          grid.classList.add('hst__people--bar');
          const fill = document.createElement('span'); fill.style.width = (count / total * 100) + '%'; grid.append(fill);
        } else {
          grid.classList.remove('hst__people--bar');
          grid.style.setProperty('--hst-columns', total === 36 ? '6' : String(Math.min(10, Math.ceil(Math.sqrt(total * 1.35)))));
          for (let i = 0; i < total; i++) {
            const mark = document.createElement('span'); mark.className = 'hst__person' + (i < count ? ' hst__person--yes' : '');
            mark.setAttribute('aria-hidden', 'true'); grid.append(mark);
          }
        }
      });
      this.querySelectorAll('[data-hst-chart]').forEach(chart => {
        try {
          const model = this.readChart(chart); this.models.push(model);
          chart.querySelector('[data-hst-chart-error]').hidden = true;
          chart.querySelector('.hst__data').open = false;
        } catch (error) {
          const message = chart.querySelector('[data-hst-chart-error]'); message.hidden = false;
          message.textContent = this.dataset.editor === 'true' ? 'Chart settings: ' + error.message : this.dataset.chartUnavailable;
          chart.querySelector('.hst__data').open = true;
        }
      });
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(entries => {
          let changed = false;
          entries.forEach(entry => {
            const width = Math.round(entry.contentRect.width);
            if (this.widths.get(entry.target) !== width) { this.widths.set(entry.target, width); changed = true; }
          });
          if (changed) this.queueDraw();
        });
        this.models.forEach(model => this.observer.observe(model.stage));
      } else window.addEventListener('resize', () => this.queueDraw(), options);
      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const model = this.models.find(item => item.stage === entry.target);
            if (!model) return;
            model.inView = entry.isIntersecting;
            if (model.inView) this.animateChart(model);
          });
        }, {threshold: 0.15});
        this.models.forEach(model => this.visibilityObserver.observe(model.stage));
      }
      document.addEventListener('shopify:block:select', event => {
        if (event.detail?.sectionId && event.detail.sectionId !== this.dataset.sectionId) return;
        if (this.panels.some(panel => panel.dataset.blockId === event.detail?.blockId)) this.show(event.detail.blockId);
      }, options);
      this.show(this.tabs[0].dataset.hstTab);
    }
    show(id) {
      this.tabs.forEach(tab => { const selected = tab.dataset.hstTab === id; tab.setAttribute('aria-selected', String(selected)); tab.tabIndex = selected ? 0 : -1; });
      this.panels.forEach(panel => {
        const selected = panel.dataset.blockId === id;
        const entering = selected && (panel.hidden || !this.activeTab);
        if (!selected && !panel.hidden) this.pauseMedia(panel);
        this.models.filter(model => model.chart.closest('[data-hst-panel]') === panel).forEach(model => {
          if (entering) model.pendingAnimation = true;
          if (!selected) {
            model.inView = false;
            model.animations?.forEach(animation => animation.cancel());
          }
        });
        panel.hidden = !selected;
        const tab = this.tabs.find(item => item.dataset.hstTab === panel.dataset.blockId);
        if (tab) panel.setAttribute('aria-labelledby', tab.id);
      });
      this.activeTab = id;
      this.queueDraw();
    }
    pauseMedia(panel) {
      panel.querySelectorAll('video').forEach(video => { try { video.pause(); } catch (_) {} });
      panel.querySelectorAll('iframe').forEach(frame => {
        try {
          const origin = new URL(frame.src).origin;
          if (/^https:\/\/(www\.)?youtube(-nocookie)?\.com$/.test(origin)) frame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), origin);
          else if (origin === 'https://player.vimeo.com') frame.contentWindow?.postMessage(JSON.stringify({method:'pause'}), origin);
        } catch (_) {}
      });
    }
    queueDraw() {
      cancelAnimationFrame(this.chartFrame);
      this.chartFrame = requestAnimationFrame(() => { if (this.isConnected) this.models.forEach(model => this.drawChart(model)); });
    }
    readChart(chart) {
      const second = chart.dataset.seriesTwo.trim();
      const lines = chart.querySelector('[data-hst-chart-data]').value.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
      const limit = chart.dataset.kind === 'bar' ? 8 : 24;
      if (!lines.length || lines.length > limit) throw new Error('Use 1–' + limit + ' data rows.');
      const parseValue = text => {
        const value = (text || '').trim();
        if (value === '' || value === '—' || value === '-') return null;
        if (!/^[-+]?(?:\d+(?:\.\d*)?|\.\d+)$/.test(value)) throw new Error('Values must be numbers with a decimal point, without units or commas.');
        const number = Number(value);
        if (!Number.isFinite(number)) throw new Error('A chart value is not finite.');
        return number;
      };
      const rows = lines.map(line => {
        const cells = line.split('|').map(cell => cell.trim());
        if (!cells[0] || cells.length < 2 || cells.length > (second ? 3 : 2)) throw new Error('Use Label | Value, or Label | First value | Second value.');
        return {label: cells[0], values: [parseValue(cells[1]), ...(second ? [parseValue(cells[2])] : [])]};
      });
      const values = rows.flatMap(row => row.values).filter(value => value !== null);
      if (!values.length) throw new Error('Enter at least one numeric value.');
      const numericX = chart.dataset.xValues.trim(); let xValues = null;
      if (numericX && chart.dataset.kind === 'line') {
        xValues = numericX.split(',').map(parseValue);
        if (xValues.length !== rows.length || xValues.some((value, i) => value === null || (i > 0 && value <= xValues[i - 1]))) throw new Error('Numeric x-values must match the row count and strictly increase.');
      }
      const minValue = Math.min(...values), maxValue = Math.max(...values);
      const inputMin = chart.dataset.yMin.trim() === '' ? null : Number(chart.dataset.yMin);
      const inputMax = chart.dataset.yMax.trim() === '' ? null : Number(chart.dataset.yMax);
      let low = inputMin !== null && Number.isFinite(inputMin) ? Math.min(inputMin, minValue) : Math.min(0, minValue);
      let high = inputMax !== null && Number.isFinite(inputMax) ? Math.max(inputMax, maxValue) : Math.max(0, maxValue);
      if (chart.dataset.kind === 'bar') { low = Math.min(0, low); high = Math.max(0, high); }
      if (high <= low) high = low + Math.max(1, Math.abs(low) * 0.1);
      if (inputMax === null) {
        const rawStep = (high - low) / 4, power = Math.pow(10, Math.floor(Math.log10(rawStep)));
        const ratio = rawStep / power; const step = (ratio <= 1 ? 1 : ratio <= 2 ? 2 : ratio <= 5 ? 5 : 10) * power;
        high = Math.ceil(high / step) * step; low = Math.floor(low / step) * step;
        if (high === low) high += step;
      }
      return {chart, stage:chart.querySelector('[data-hst-chart-stage]'), rows, values, low, high, xValues, names:[chart.dataset.seriesOne, ...(second ? [second] : [])], kind:chart.dataset.kind};
    }
    drawChart(model) {
      if (model.chart.closest('[data-hst-panel]').hidden) return;
      const width = Math.round(model.stage.getBoundingClientRect().width);
      if (width < 100) return;
      model.animations?.forEach(animation => animation.cancel());
      model.animations = [];
      const {chart, rows, low, high, names, kind, xValues} = model;
      const height = width < 300 ? 280 : 320;
      const decimals = Math.min(8, Math.max(2, -Math.floor(Math.log10((high-low)/4))));
      const number = value => new Intl.NumberFormat(undefined, {maximumFractionDigits:decimals}).format(value);
      const suffix = chart.dataset.suffix || '';
      const maxTickChars = Math.max(number(low).length, number(high).length) + suffix.length;
      const margin = {left:Math.min(width * .32, Math.max(43, maxTickChars * 6.4 + 9)), right:14, top:38, bottom:64};
      const plotWidth = width - margin.left - margin.right, plotHeight = height - margin.top - margin.bottom;
      const ns = 'http://www.w3.org/2000/svg';
      const element = (tag, attributes, text) => { const node = document.createElementNS(ns, tag); Object.entries(attributes || {}).forEach(([key, value]) => node.setAttribute(key, String(value))); if (text !== undefined) node.textContent = text; return node; };
      const svg = element('svg', {viewBox:`0 0 ${width} ${height}`, role:'img', 'aria-label':chart.dataset.title + '. ' + chart.dataset.yLabel + '. ' + rows.map(row => row.label + ': ' + row.values.map((value, index) => names[index] + ' ' + (value === null ? 'not reported' : number(value) + suffix)).join(', ')).join('; ')});
      svg.append(element('title', {}, chart.dataset.title));
      svg.append(element('text', {x:0,y:14,class:'hst__axis-label'}, chart.dataset.yLabel));
      const y = value => margin.top + plotHeight * (high - value) / (high - low);
      for (let i = 0; i <= 4; i++) {
        const value = low + (high - low) * i / 4, yy = y(value);
        svg.append(element('line', {x1:margin.left,x2:width-margin.right,y1:yy,y2:yy,class:'hst__gridline'}));
        svg.append(element('text', {x:margin.left-9,y:yy+4,'text-anchor':'end'}, number(value)+suffix));
      }
      const barStep = plotWidth / rows.length;
      const x = index => {
        if (kind === 'bar') return margin.left + barStep * (index + .5);
        if (rows.length === 1) return margin.left + plotWidth / 2;
        if (xValues) return margin.left + 7 + (plotWidth-14) * (xValues[index] - xValues[0]) / (xValues.at(-1) - xValues[0]);
        return margin.left + 7 + (plotWidth-14) * index / (rows.length - 1);
      };
      const drawLabel = (text, xx, yy, room, anchor='middle') => {
        const max = Math.max(3, Math.floor(room / 6.2));
        const words = text.split(/\s+/), lines = [''];
        words.forEach(word => { const last = lines.length-1; if ((lines[last]+' '+word).trim().length > max && lines[last]) lines.push(word); else lines[last] = (lines[last]+' '+word).trim(); });
        const node = element('text', {x:xx,y:yy,'text-anchor':anchor});
        lines.slice(0,2).forEach((line,index) => { const truncated = line.length > max || (index === 1 && lines.length > 2); node.append(element('tspan',{x:xx,dy:index?14:0},truncated?line.slice(0,max-1)+'…':line)); });
        node.append(element('title',{},text));svg.append(node);
      };
      const tickLimit = width < 380 ? 3 : 5;
      const every = kind === 'line' ? Math.max(1,Math.ceil((rows.length-1)/(tickLimit-1))) : 1;
      rows.forEach((row,index) => {
        if (kind === 'line' && index % every !== 0 && index !== rows.length-1) return;
        const anchor = kind === 'line' && index === 0 ? 'start' : kind === 'line' && index === rows.length-1 ? 'end' : 'middle';
        drawLabel(row.label,x(index),margin.top+plotHeight+19,kind==='bar'?barStep-3:plotWidth/Math.min(tickLimit,rows.length),anchor);
      });
      svg.append(element('text',{x:margin.left+plotWidth/2,y:height-5,'text-anchor':'middle',class:'hst__axis-label'},chart.dataset.xLabel));
      const showValues = chart.dataset.showValues === 'true';
      if (kind === 'bar') {
        const zero = y(0), gap = names.length === 2 ? 4 : 0;
        const barWidth = Math.min(72,(barStep*.68-gap)/names.length);
        rows.forEach((row,index) => row.values.forEach((value,series) => {
          if (value === null) return;
          const xx = x(index) - (barWidth*names.length+gap)/2 + series*(barWidth+gap);
          const rect = element('rect',{x:xx,y:Math.min(zero,y(value)),width:barWidth,height:Math.abs(zero-y(value)),rx:2,'data-hst-bar-sign':value < 0 ? 'negative' : 'positive',class:series?'hst__bar-two':'hst__bar-one'});
          rect.append(element('title',{},row.label+' — '+names[series]+': '+number(value)+suffix));svg.append(rect);
          if (showValues && barWidth > 26 && value >= 0) svg.append(element('text',{x:xx+barWidth/2,y:y(value)-8,'text-anchor':'middle'},number(value)+suffix));
        }));
        svg.append(element('line',{x1:margin.left,x2:width-margin.right,y1:zero,y2:zero,class:'hst__axis-line'}));
      } else {
        const lineLayer = element('g', {'data-hst-line-layer':''});
        svg.append(lineLayer);
        names.forEach((name,series) => {
          let path = '', connected = false;
          rows.forEach((row,index) => { const value=row.values[series];if(value===null){connected=false;return;}path+=(connected?' L ':' M ')+x(index)+' '+y(value);connected=true; });
          lineLayer.append(element('path',{d:path,class:series?'hst__line-two':'hst__line-one'}));
          rows.forEach((row,index) => {
            const value=row.values[series];if(value===null)return;
            const point=element('circle',{cx:x(index),cy:y(value),r:4,class:series?'hst__point-two':'hst__point-one'});
            point.append(element('title',{},row.label+' — '+name+': '+number(value)+suffix));lineLayer.append(point);
            if(showValues&&names.length===1&&rows.length<=5&&width>=300)lineLayer.append(element('text',{x:x(index),y:y(value)-10,'text-anchor':index===0?'start':index===rows.length-1?'end':'middle'},number(value)+suffix));
          });
        });
      }
      const legend=document.createElement('div');legend.className='hst__chart-key';
      names.forEach(name=>{const span=document.createElement('span'),mark=document.createElement('i');mark.setAttribute('aria-hidden','true');span.append(mark,document.createTextNode(name));legend.append(span);});
      model.stage.replaceChildren(svg,legend);
      this.animateChart(model);
    }
    animateChart(model) {
      if (!model.pendingAnimation || !model.stage.querySelector('svg') || model.chart.closest('[data-hst-panel]').hidden) return;
      if (this.visibilityObserver && !model.inView) return;
      model.pendingAnimation = false;
      if (this.dataset.animateCharts === 'false' || this.motionPreference.matches) return;
      const bars = [...model.stage.querySelectorAll('[data-hst-bar-sign]')];
      const targets = bars.length ? bars : [...model.stage.querySelectorAll('[data-hst-line-layer]')];
      targets.forEach((node, index) => {
        if (typeof node.animate !== 'function') return;
        const from = bars.length
          ? (node.dataset.hstBarSign === 'negative' ? 'inset(0 0 100% 0)' : 'inset(100% 0 0 0)')
          : 'inset(-5% 100% -5% 0)';
        const to = bars.length ? 'inset(0 0 0 0)' : 'inset(-5% -5% -5% -5%)';
        const animation = node.animate([{clipPath:from},{clipPath:to}], {
          duration: bars.length ? 700 : 1000,
          delay: bars.length ? Math.min(index * 70, 280) : 0,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill:'backwards'
        });
        model.animations.push(animation);
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haroutine-study-ritual"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('haroutine-ritual-purchase')) return;
  class HaroutineRitualPurchase extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.initialize()); }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.events?.abort();
      this.pendingRequest?.abort();
      if (this.dialog?.open) this.dialog.close();
      this.unlockScroll();
    }
    query(name) { return this.querySelector(`[data-hcr-${name}]`); }
    initialize() {
      this.events?.abort();
      this.events = new AbortController();
      const options = {signal:this.events.signal};
      this.dialog = this.query('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      try { this.product = JSON.parse(this.query('product').textContent); } catch (_) { return; }
      if (!this.product.variants?.length) return;
      this.variant = this.product.variants[0];
      this.hasAnyPlans = this.product.variants.some(v => v.plans.length);
      this.form = this.query('form');
      this.variantSelect = this.query('variant-select');
      this.planSelect = this.query('plan-select');
      this.submit = this.query('submit');
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-hcr-open]');
        if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
        try { this.open(trigger); event.preventDefault(); } catch (_) { /* Real PDP links remain the fallback. */ }
      }, options);
      this.query('close').addEventListener('click', () => { if (!this.busy) this.dialog.close(); }, options);
      this.query('continue').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('cancel', event => { if (this.busy) event.preventDefault(); }, options);
      this.dialog.addEventListener('pointerdown', event => { this.backdropStart = this.isBackdrop(event); }, options);
      this.dialog.addEventListener('click', event => {
        if (this.backdropStart && this.isBackdrop(event) && !this.busy) this.dialog.close();
        this.backdropStart = false;
        if (this.busy && event.target.closest('a')) event.preventDefault();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.unlockScroll();
        if (!this.handingOffCart && this.trigger?.isConnected) this.trigger.focus({preventScroll:true});
        this.handingOffCart = false;
      }, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const nodes = [...this.dialog.querySelectorAll('a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex="0"]')]
          .filter(el => el.getClientRects().length && (el.type !== 'radio' || el.checked));
        const first = nodes[0], last = nodes[nodes.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }, options);
      this.variantSelect.addEventListener('change', () => {
        if (this.busy) return;
        this.variant = this.product.variants.find(v => String(v.id) === this.variantSelect.value);
        this.renderPlans();
      }, options);
      this.planSelect.addEventListener('change', () => { if (!this.busy) { this.clearError(); this.renderPrice(); } }, options);
      this.querySelectorAll('[data-hcr-mode]').forEach(radio => radio.addEventListener('change', () => {
        if (!this.busy && radio.checked) { this.mode = radio.value; this.clearError(); this.renderPrice(); }
      }, options));
      this.form.addEventListener('submit', event => this.addToBag(event), options);
    }
    open(trigger) {
      if (this.busy) return;
      this.trigger = trigger;
      this.mode = this.product.requiresPlan ? 'subscription' : trigger.dataset.hcrOpen;
      this.added = false;
      this.form.hidden = false;
      this.form.removeAttribute('aria-busy');
      this.query('success').hidden = true;
      this.setBusy(false);
      this.variantSelect.replaceChildren(...this.product.variants.map(v => new Option(v.title + (!v.available ? ' — Sold out' : ''), String(v.id))));
      this.variantSelect.value = String(this.variant.id);
      this.query('variant-field').hidden = this.product.variants.length < 2;
      this.renderPlans();
      this.dialog.showModal();
      this.dialog.scrollTop = 0;
      this.lockScroll();
    }
    isBackdrop(event) {
      if (event.target !== this.dialog) return false;
      const r = this.dialog.getBoundingClientRect();
      return event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom;
    }
    lockScroll() {
      const state = HaroutineRitualPurchase.scroll;
      if (state.owners.has(this)) return;
      if (!state.owners.size) {
        state.styles = [[document.documentElement,'overflow'],[document.body,'overflow'],[document.body,'padding-right']]
          .map(([el,p]) => [el,p,el.style.getPropertyValue(p),el.style.getPropertyPriority(p)]);
        const gutter = Math.max(0, innerWidth - document.documentElement.clientWidth);
        const padding = parseFloat(getComputedStyle(document.body).paddingRight) || 0;
        document.documentElement.style.setProperty('overflow','hidden','important');
        document.body.style.setProperty('overflow','hidden','important');
        if (gutter) document.body.style.setProperty('padding-right',`${padding + gutter}px`,'important');
      }
      state.owners.add(this);
    }
    unlockScroll() {
      const state = HaroutineRitualPurchase.scroll;
      if (!state.owners.delete(this) || state.owners.size) return;
      state.styles?.forEach(([el,p,value,priority]) => value ? el.style.setProperty(p,value,priority) : el.style.removeProperty(p));
      state.styles = null;
    }
    renderPlans() {
      const previous = this.planSelect.value;
      const plans = this.variant.plans;
      this.planSelect.replaceChildren(...plans.map(p => new Option(p.name,String(p.id))));
      const direct = plans.filter(p => p.direct);
      const preferred = plans.find(p => String(p.id) === previous) || (direct.length ? direct : plans).reduce((best,p) => !best || p.price < best.price ? p : best, null);
      if (preferred) this.planSelect.value = String(preferred.id);
      const image = this.query('image');
      this.query('image-wrap').hidden = !this.variant.image;
      image.hidden = !this.variant.image;
      if (this.variant.image) { image.src = this.variant.image; image.alt = this.variant.imageAlt; }
      else image.removeAttribute('src');
      this.query('variant-caption').textContent = this.variant.title === 'Default Title' ? '' : this.variant.title;
      this.query('variant-input').value = String(this.variant.id);
      if (this.variant.requiresPlan) this.mode = 'subscription';
      this.clearError(); this.renderPrice();
    }
    frequency(plan) {
      const option = plan.options.find(o => /order frequency and unit/i.test(o.name));
      const match = option?.value?.match(/^(\d+)-(day|week|month|year)s?$/i);
      if (!match) return {label:plan.name,renewal:'Renews automatically according to the selected plan.'};
      const amount = Number(match[1]), unit = match[2].toLowerCase();
      const label = amount === 1 ? 'Every ' + unit : 'Every ' + amount + ' ' + unit + 's';
      return {label,renewal:'Renews automatically ' + label.toLowerCase() + '.'};
    }
    renderPrice() {
      this.plan = this.variant.plans.find(p => String(p.id) === this.planSelect.value);
      const subscribing = this.mode === 'subscription';
      const requiresPlan = Boolean(this.product.requiresPlan || this.variant.requiresPlan);
      const allowed = subscribing ? Boolean(this.plan?.direct) : !requiresPlan;
      this.query('once-label').hidden = requiresPlan;
      this.query('sub-label').hidden = !this.hasAnyPlans;
      this.query('once-price').textContent = this.variant.priceLabel;
      this.query('sub-price').textContent = this.plan ? (this.plan.direct ? this.plan.priceLabel : 'See details') : 'Unavailable';
      this.querySelectorAll('[data-hcr-mode]').forEach(radio => {
        radio.checked = radio.value === this.mode;
        const disabled = radio.value === 'once' ? requiresPlan : !this.variant.plans.length;
        radio.disabled = disabled || this.busy;
        radio.closest('label').classList.toggle('is-selected',radio.checked);
        radio.closest('label').classList.toggle('is-disabled',disabled);
      });
      this.query('plan-field').hidden = !subscribing || this.variant.plans.length < 2;
      this.query('plan-input').disabled = !subscribing || !this.plan;
      this.query('plan-input').value = subscribing && this.plan ? String(this.plan.id) : '';
      this.query('price-box').hidden = !allowed;
      this.query('frequency-row').hidden = !subscribing;
      this.query('perks')?.toggleAttribute('hidden',!subscribing || !allowed);
      this.submit.hidden = subscribing && this.plan && !this.plan.direct;
      this.submit.disabled = !allowed || !this.variant.available || this.busy;
      this.submit.textContent = !this.variant.available ? 'Sold out' : (subscribing ? 'Add subscription to bag' : 'Add to bag');
      const link = this.query('product-link');
      const url = new URL(this.product.url,location.origin);
      url.searchParams.set('variant',String(this.variant.id));
      if (subscribing && this.plan) url.searchParams.set('selling_plan',String(this.plan.id));
      link.href = url.toString();
      link.textContent = subscribing && this.plan && !this.plan.direct ? 'Review this plan on the product page' : 'View full product details';
      this.query('next-price').textContent = '';
      if (!subscribing) {
        this.query('price').textContent = this.variant.priceLabel;
        this.query('period').textContent = 'One-time purchase';
        this.query('terms').textContent = 'One-time purchase. No recurring deliveries.';
      } else if (!this.plan) {
        this.query('terms').textContent = 'A subscription is not available for this size. Choose another size or buy once if available.';
      } else if (!this.plan.direct) {
        this.query('terms').textContent = 'Review the full payment and delivery schedule on the product page before subscribing.';
      } else {
        const [first,second] = this.plan.stages;
        const count = Number(first?.orders) || 0;
        const changes = Boolean(second && count > 0);
        const firstPrice = first?.label || this.plan.priceLabel;
        this.query('price').textContent = firstPrice;
        this.query('period').textContent = changes ? 'First ' + count + (count === 1 ? ' order' : ' orders') : 'Per delivery';
        this.query('next-price').textContent = changes ? 'Then ' + second.label + ' per order.' : '';
        const frequency = this.frequency(this.plan);
        this.query('frequency').textContent = frequency.label;
        const amounts = changes ? firstPrice + ' per order for the first ' + count + (count === 1 ? ' order, then ' : ' orders, then ') + second.label + ' per order.' : firstPrice + ' per delivery.';
        this.query('terms').textContent = amounts + ' ' + frequency.renewal + ' ' + (this.dataset.subscriptionTerms || '');
      }
    }
    setBusy(value) {
      this.busy = value;
      this.variantSelect.disabled = value;
      this.planSelect.disabled = value;
      this.query('close').disabled = value;
      this.querySelectorAll('[data-hcr-mode]').forEach(el => { el.disabled = value; });
      if (value) { this.form.setAttribute('aria-busy','true'); this.submit.disabled = true; this.submit.textContent = 'Adding…'; }
      else this.form.removeAttribute('aria-busy');
    }
    clearError() { this.query('error').hidden = true; this.query('error').textContent = ''; }
    showCompletion(message) {
      this.setBusy(false);
      this.added = true;
      this.form.hidden = true;
      this.query('success-message').textContent = message;
      this.query('success').hidden = false;
      this.query('success').focus({preventScroll:true});
    }
    async openUpdatedCart(drawer,data) {
      const sections = drawer.getSectionsToRender();
      const valid = payload => sections.every(section => typeof payload?.[section.id] === 'string' && new DOMParser().parseFromString(payload[section.id],'text/html').querySelector(section.selector || '.shopify-section'));
      if (!valid(data?.sections)) {
        const url = new URL(location.href); url.hash = '';
        url.searchParams.set('sections',sections.map(s => s.id).join(','));
        const response = await fetch(url.toString(),{credentials:'same-origin',headers:{Accept:'application/json'},signal:this.pendingRequest.signal});
        if (!response.ok) throw new Error('Cart preview unavailable');
        data = {...data,sections:await response.json()};
      }
      if (!valid(data.sections)) throw new Error('Cart preview unavailable');
      this.handingOffCart = true;
      this.dialog.close();
      this.unlockScroll();
      drawer.setActiveElement?.(this.trigger);
      drawer.classList.remove('is-empty');
      drawer.renderContents({...data,id:data.id || data.items?.[0]?.id});
    }
    async syncCartTotal() {
      try {
        const response = await fetch(this.dataset.cartUrl + '.js',{credentials:'same-origin',headers:{Accept:'application/json'},signal:this.pendingRequest.signal});
        if (!response.ok) return;
        const cart = await response.json();
        if (typeof cart.total_price === 'number') document.dispatchEvent(new CustomEvent('haroutine-cart-updated',{bubbles:true,detail:cart}));
      } catch (_) { /* A failed total refresh never retries an add. */ }
    }
    async addToBag(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.busy || this.added || !this.variant?.available) return;
      if (this.mode === 'subscription' ? !this.plan?.direct : (this.product.requiresPlan || this.variant.requiresPlan)) return;
      this.clearError(); this.setBusy(true);
      this.pendingRequest = new AbortController();
      const timer = setTimeout(() => this.pendingRequest?.abort(),20000);
      const item = {id:this.variant.id,quantity:1};
      if (this.mode === 'subscription') item.selling_plan = this.plan.id;
      const drawer = document.querySelector('cart-drawer');
      const canRenderDrawer = typeof drawer?.getSectionsToRender === 'function' && typeof drawer?.renderContents === 'function';
      let data;
      try {
        const request = {items:[item]};
        if (canRenderDrawer) { request.sections = drawer.getSectionsToRender().map(s => s.id); request.sections_url = location.pathname; }
        const response = await fetch(this.dataset.cartAddUrl,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(request),signal:this.pendingRequest.signal});
        try { data = await response.json(); } catch (_) { data = null; }
        if (!response.ok || data?.status >= 400) {
          if (response.status >= 500) throw new Error('Could not confirm cart update');
          this.setBusy(false); this.renderPrice();
          this.query('error').textContent = typeof data?.description === 'string' ? data.description : 'This option could not be added. Please review your selection.';
          this.query('error').hidden = false;
          return;
        }
      } catch (_) {
        if (!this.isConnected) return;
        this.showCompletion('We could not confirm the cart update. Please check your bag before trying again.');
        return;
      } finally { clearTimeout(timer); }
      if (!this.isConnected) return;
      this.showCompletion('Added to your bag.');
      const renderTimer = setTimeout(() => this.pendingRequest?.abort(),15000);
      if (canRenderDrawer) {
        try { await this.openUpdatedCart(drawer,data); }
        catch (_) {
          if (!this.isConnected) return;
          await new Promise(resolve => requestAnimationFrame(resolve));
          if (!this.dialog.open) { this.dialog.showModal(); this.lockScroll(); }
          this.showCompletion('Added to your bag. The cart preview could not be refreshed. Please check your bag before adding again.');
        }
      }
      await this.syncCartTotal();
      clearTimeout(renderTimer);
    }
  }
  HaroutineRitualPurchase.scroll = {owners:new Set(),styles:null};
  customElements.define('haroutine-ritual-purchase',HaroutineRitualPurchase);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.querySelector('.announcement-bar-section').classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.querySelector('.announcement-bar-section').classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.querySelector('.announcement-bar-section').classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Open on hover
  // https://community.shopify.com/c/shopify-design/open-drop-down-to-mega-menu-on-hover-in-dawn-theme/td-p/1754347
  let items = document.querySelectorAll('.mega-menu');
  let header = document.querySelector('header');
  let currentItemIndex;
  
  items.forEach((item, itemIndex) => {
    const content = item.querySelector('.mega-menu__content')
    item.addEventListener('mouseover', () => {
      if (
        (currentItemIndex === 0 && currentItemIndex !== itemIndex) ||
        (currentItemIndex && currentItemIndex !== itemIndex)
      ) {
        items[currentItemIndex].removeAttribute('open');
        document.body.classList.remove('megamenu-open');
      }

      currentItemIndex = itemIndex;
      item.setAttribute('open', true);
      document.body.classList.add('megamenu-open');
    });

    item.addEventListener('mouseleave', (event) => {
      /*
      let close = true;

      const closeTimeout = setTimeout(() => {
        if (close) {
          item.removeAttribute('open');
          document.body.classList.remove('megamenu-open');
        }
      }, 200);
      
      content.addEventListener('mouseover', () => {
        close = false;
      });

      item.addEventListener('mouseover', () => {
        clearTimeout(closeTimeout);
      });
      */
      item.removeAttribute('open');
      document.body.classList.remove('megamenu-open');
    });

    content.addEventListener('mouseleave', () => {
      item.removeAttribute('open');
      document.body.classList.remove('megamenu-open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inner-beauty"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('inner-beauty')) {
    class InnerBeauty extends HTMLElement {
      elements;
      list_collection;
      slider;
      thumbs;
      selected_group;
      sid;

      constructor(sid) {
        super();

        this.sid = sid;

        this.elements = {
          slider: document.querySelector(`#shopify-section-${this.sid} [data-inner-beauty-slider].swiper`),
          thumbs: document.querySelector(`#shopify-section-${this.sid} [data-inner-beauty-slider-thumbs].swiper`),
        };
      }

      initSlider = () => {
        if (!this.elements.slider) {
          return;
        }

        const main_slider_settings = {
          a11y: true,
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          autoheight: false,
          freeMode: false,
          autoplay: {
            delay: 50000,
          },
          pagination: {
            el: `#shopify-section-${this.sid} .swiper-pagination`,
            clickable: true,
          },
        };

        if (this.elements.thumbs) {
          this.thumbs = new Swiper(`#shopify-section-${this.sid} [data-inner-beauty-slider-thumbs].swiper`, {
            loop: true,
            spaceBetween: 10,
            slidesPerView: 3,
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: {
              990: {
                spaceBetween: 20,
                direction: 'vertical',
              },
              1300: {
                spaceBetween: 10,
                direction: 'horizontal',
              }
            }
          });
          
          main_slider_settings.thumbs = {
            swiper: this.thumbs,
          };
        }

        this.slider = new Swiper(`#shopify-section-${this.sid} [data-inner-beauty-slider].swiper`, main_slider_settings);
      };
    }

    customElements.define('inner-beauty', InnerBeauty);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredients"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('product-ingredients')) {
  class ProductIngredients extends HTMLElement {
    elements;
    sid;

    constructor(sid) {
      super();

      this.sid = sid;

      this.elements = {
        accordion_items: document.querySelectorAll(`#shopify-section-${this.sid} .product-ingredients__accordion-item`),
        garantee_items: document.querySelectorAll(`#shopify-section-${this.sid} [data-garantee-item]`),
      };
    }

    initAccordion = () => {
      const open_class = 'product-ingredients__accordion-item--open';
      const accordion_items = this.elements.accordion_items;

      for (let i = 0; i < accordion_items.length; i++) {
        accordion_items[i].addEventListener('click', (e) => {
          // Allow clicking so child elements instead of closing accordion item
          if (e.target.closest('.product-ingredients__guarantee') !== null) {
            return;
          }

          const item = e.currentTarget;
          const is_opened = item.classList.contains(open_class);

          for (let j = 0; j < accordion_items.length; j++) {
            accordion_items[j].classList.remove(open_class);
          }

          if (!is_opened) {
            item.classList.toggle(open_class);
          }
        });
      }
    };

    initGuarantees = () => {
      const garantee_items = this.elements.garantee_items;

      for (let i = 0; i < garantee_items.length; i++) {
        garantee_items[i].addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const item = e.currentTarget;

          if (typeof item.dataset.garanteeItem === 'undefined' || typeof item.dataset.garanteeItemModalImage === 'undefined') {
            console.error('Missing data attribute');
            return;
          }

          $(`#${item.dataset.modal}`).modal();
        });
      }
    };
  }

  customElements.define('product-ingredients', ProductIngredients);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-list')) {
    class ProductList extends HTMLElement {
      elements;
      list_collection;
      swiper_product_list;
      selected_group;
      product_limit;
      arrows_position;
      sid;
      has_filters;
      
      constructor(sid) {
        super();

        this.sid = sid;

        this.elements = {
          slider: document.querySelector(`#shopify-section-${this.sid} [data-product-list-slider].swiper`),
          groupTags: document.querySelectorAll(`#shopify-section-${this.sid} .product-list__filters li`),
          changeCardVariant: document.querySelectorAll(`#shopify-section-${this.sid} .card__variant`),
        };
  
        this.product_limit = this.elements.slider.dataset.limit;
        this.arrows_position = this.elements.slider.dataset.arrows;
        this.has_filters = (this.elements.slider.dataset.hasFilters === true || this.elements.slider.dataset.hasFilters === 'true');
        this.list_collection = (this.has_filters == true) ? JSON.parse(document.querySelector(`#shopify-section-${this.sid} [data-product-list-json="${this.sid}"]`).textContent) : [];
        this.swiper_product_list = null;
        this.selected_group = 'shop-all';

        if (this.elements.groupTags.length && this.has_filters == true) {
          Array.from(this.elements.groupTags).forEach((element) => {
            element.addEventListener('click', this.changeGroup.bind(this));
          });
        }
  
        // Dynamically added elements
        if (this.elements.changeCardVariant.length) {
          document.addEventListener('click', this.selectCardVariant.bind(this));
        }
      }
  
      initSlider = () => {
        const slider_settings = {
          a11y: true,
          slidesPerView: 1.5,
          spaceBetween: 20,
          loop: true,
          autoheight: false,
          freeMode: true,
          breakpoints: {
            768: {
              loop: false,
              slidesPerView: 2.5,
              slidesPerGroup: 2.5,
              navigation: {
                enabled: (this.arrows_position !== 'none'),
                nextEl: `#shopify-section-${this.sid} .product-list .swiper-button-next`,
                prevEl: `#shopify-section-${this.sid} .product-list .swiper-button-prev`,
              },
            },
            990: {
              loop: false,
              slidesPerView: 3,
              slidesPerGroup: 3,
              navigation: {
                enabled: (this.arrows_position !== 'none'),
                nextEl: `#shopify-section-${this.sid} .product-list .swiper-button-next`,
                prevEl: `#shopify-section-${this.sid} .product-list .swiper-button-prev`,
              },
            },
            1200: {
              loop: false,
              slidesPerView: 4,
              slidesPerGroup: 4,
              navigation: {
                enabled: (this.arrows_position !== 'none'),
                nextEl: `#shopify-section-${this.sid} .product-list .swiper-button-next`,
                prevEl: `#shopify-section-${this.sid} .product-list .swiper-button-prev`,
              },
            }
          }
        };

        if (this.elements.slider.dataset.scrollbar === 'true') {
          slider_settings.scrollbar = {
            el: `#shopify-section-${this.sid} .swiper-scrollbar`,
            draggable: true,
          };
        }

        this.swiper_product_list = new Swiper(`#shopify-section-${this.sid} [data-product-list-slider].swiper`, slider_settings);
      };
  
      changeGroup = (e) => {
        const item = e.currentTarget;
        const item_group = item.dataset.group

        if (this.selected_group === item_group) {
          return;
        }
  
        this.selected_group = item_group;
  
        Array.from(this.elements.groupTags).forEach((element) => {
          element.classList.remove('active');
        });
  
        item.classList.add('active');
        
        // Find all products assigned to the same group
        let matching_products = [];
        if (item_group === 'shop-all') {
          matching_products = this.list_collection;
        } else {
          matching_products = this.list_collection.filter(product => {
            return product.tags.includes(`group:${item_group}`);
          });
        }
  
        if (matching_products.length > this.product_limit) {
          matching_products = matching_products.slice(0, this.product_limit - 1);
        }
  
        this.swiper_product_list.removeAllSlides();
  
        Array.from(matching_products).forEach((element) => {
          const new_slide = product_list_html.find(element_html => element_html.includes(String(element.id)));
          if (typeof new_slide !== 'undefined') {
            this.swiper_product_list.appendSlide(new_slide);
          }
        });
        
        return matching_products;
      };
  
      selectCardVariant = (e) => {
        const item = e.target.closest('.card__variant');
        if (!item) { return; }
  
        if (item.classList.contains('active')) { return; }
  
        Array.from(item.closest('.card__variants').querySelectorAll('.card__variant')).forEach((element) => {
          element.classList.remove('active');
        });
  
        item.classList.add('active');
  
        const card = item.closest('.card-wrapper');
        card.querySelector('.card__selected-option').innerHTML = item.dataset.variantSize;
        card.querySelector('.card__selected-option').dataset.optionValueHandle = item.dataset.variantSizeHandle;
        card.querySelector('.card__media .media img').src = item.dataset.variantImage;
        card.querySelector('.card__media .media img').removeAttribute('srcset');
  
        if (item.dataset.variantAvailable === true || item.dataset.variantAvailable === 'true') {
          card.querySelector('.quick-add .sold-out-message').classList.add('hidden');
          card.querySelector('.quick-add .quick-add__buy-now').classList.remove('hidden');
          card.querySelector('.quick-add .quick-add__submit').disabled = false;
          card.querySelector('.quick-add .product-variant-id').value = item.dataset.variantId;
        } else {
          card.querySelector('.quick-add .sold-out-message').classList.remove('hidden');
          card.querySelector('.quick-add .quick-add__buy-now').classList.add('hidden');
          card.querySelector('.quick-add .quick-add__submit').disabled = true;
          card.querySelector('.quick-add .product-variant-id').value = '';
        }
      };
    }

    customElements.define('product-list', ProductList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reviews-list')) {
    class ReviewsList extends HTMLElement {
      elements;
      slider;
      sid;

      constructor(sid) {
        super();

        this.sid = sid;

        this.elements = {
          slider: document.querySelector(`#shopify-section-${this.sid} [data-reviews-list-slider].swiper`),
        };
      }
  
      initSlider = () => {
        this.slider = new Swiper(`#shopify-section-${this.sid} [data-reviews-list-slider].swiper`, {
          a11y: true,
          slidesPerView: 1.5,
          spaceBetween: 20,
          loop: true,
          autoheight: false,
          freeMode: true,
          scrollbar: {
            el: `#shopify-section-${this.sid} .swiper-scrollbar`,
            draggable: true,
          },
          breakpoints: {
            990: {
              slidesPerView: 3,
              slidesPerGroup: 3,
              spaceBetween: 80,
              loop: false,
              navigation: {
                enabled: true,
                nextEl: `#shopify-section-${this.sid} .reviews-list .swiper-button-next`,
                prevEl: `#shopify-section-${this.sid} .reviews-list .swiper-button-prev`,
              },
            }
          }
        });
      };
    }

    customElements.define('reviews-list', ReviewsList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["study-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('study-grid')) {
    class StudyGrid extends HTMLElement {
      elements;
      sid;
      blogTitle;
      blogHandle;
      articles;
      articlesTags;
      filters;
      selectedFilter;
      totalArticlesToShow;

      constructor(sid, blog_title, blog_handle) {
        super();

        this.sid = sid;
        this.blogTitle = blog_title;
        this.blogHandle = blog_handle;
        this.articles = [];
        this.articlesTags = [];
        this.filters = [];
        this.selectedFilter = ''; // '' is 'any'/'all'
        this.totalArticlesToShow = 20;

        this.elements = {
          filterList: document.querySelector(`#shopify-section-${this.sid} [data-study-filter-list]`),
          grid: document.querySelector(`#shopify-section-${this.sid} [data-study-grid-items]`),
        };
      }

      init = async () => {
        this.articles = await this.loadArticles();

        if (this.articles.length === 0 || !this.elements.filterList) {
          return false;
        }

        this.articlesTags = await this.loadTags();

        await this.initFilters();
      };

      populateArticles = () => {
        this.elements.grid.innerHTML = '';

        if (this.articles.length === 0) {
          this.elements.grid.innerHTML = '<p class="study-grid__item-no-results>No results</p>';
          return;
        }

        for (let i = 0; i < this.articles.length; i++) {
          const article = this.articles[i].node;
          const article_element = document.createElement('div');
          article_element.classList.add('study-grid__item');
          article_element.classList.add('scroll-trigger');
          article_element.classList.add('animate--slide-in');

          let article_html = ``;
          if (article.title.length !== 0) {
            article_html += `<h4 class="study-grid__item-title">${article.title}</h4>`;
          }

          if (article.excerptHtml.length !== 0) {
            article_html += `<p class="study-grid__item-excerpt">${article.excerptHtml}</p>`;
          }

          const reference = article.metafields.find((metafield) => {
            return metafield?.namespace === 'haroutine' && metafield?.key === 'reference';
          });

          if (typeof reference !== 'undefined') {
            article_html += `<p class="study-grid__item-reference">${reference.value}</p>`;
          }

          const external_resource = article.metafields.find((metafield) => {
            return metafield?.namespace === 'haroutine' && metafield?.key === 'external_resource';
          });

          if (typeof external_resource === 'undefined') {
            article_html += `<a href="/blogs/${this.blogHandle}/${article.handle}" class="study-grid__item-link" target="_blank">Read the Study</a>`;
          } else {
            article_html += `<a href="${external_resource.value}" class="study-grid__item-link" target="_blank">Read the Study</a>`;
          }

          article_element.innerHTML = article_html;
          this.elements.grid.appendChild(article_element);
        }
      };

      // Extract the filter tags and populate the filters list
      initFilters = () => {
        const extract_filters = [];

        for (let i = 0; i < this.articlesTags.length; i++) {
          const article = this.articlesTags[i].node;
 
          for (let j = 0; j < article.tags.length; j++) {
            const tag = article.tags[j];
            if (tag.includes('filter:')) {
              extract_filters.push(tag.replace('filter:', ''));
            }
          }
        }

        // Unique filters
        this.filters = [...new Set(extract_filters)];

        // Order alphabetically
        this.filters = this.filters.sort((a, b) => a.localeCompare(b));

        // Populate list
        for (let i = 0; i < this.filters.length; i++) {
          const filter = this.filters[i];

          const option = document.createElement('option');
          option.text = filter;
          option.value = filter;
          this.elements.filterList.appendChild(option);
        }

        $(`#shopify-section-${this.sid} [data-study-filter-list]`).selectric({
          arrowButtonMarkup: '<b class="button"><svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none"><path d="M8.75 13.125L17.5 21.875L26.25 13.125" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></b>',
          disableOnMobile: false,
          nativeOnMobile: false,
          onInit: (element) => {
            this.populateArticles();
          },
          onChange: async (element) => {
            this.selectedFilter = document.querySelector(`#shopify-section-${this.sid} [data-study-grid-filters] .selectric-scroll .selected`).innerText;
            this.articles = await this.loadArticles();
            this.populateArticles();
          },
        }); 
      };
  
      // Send query to Storefront API
      sendQuery = async (query, query_variables = null) => {
        const body = {
          query,
        };

        if (query_variables !== null) {
          body.variables = query_variables;
        }

        const response = await fetch(`https://${window.Shopify.shop}/api/2024-10/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': (window.Shopify.shop.includes('development')) ? '91578dd1fd999fee94019ad21a94eab6' : 'f68687034845eabfdb273423f640012a',
          },
          body: JSON.stringify(body),
        });

        return response;
      };

      // Create query and validate result
      loadArticles = async () => {
        let query_filter = `blog_title:${this.blogTitle}`;
        if (this.selectedFilter !== '' && this.selectedFilter.trim() !== '' && this.selectedFilter !== 'Any') {
          const cleanFilter = this.selectedFilter.trim().replace(/"/g, '\\"');
          query_filter += ` AND tag:"filter:${cleanFilter}"`;
        }

        const query = `
          query GetFilteredArticles($queryFilter: String!) {
            articles(first: ${this.totalArticlesToShow}, query: $queryFilter) {
              edges {
                node {
                  id
                  handle
                  title
                  tags
                  excerptHtml
                  metafields(
                    identifiers: [
                      {namespace: "haroutine", key: "category"},
                      {namespace: "haroutine", key: "reference"},
                      {namespace: "haroutine", key: "external_resource"}
                    ]
                  ) {
                    key
                    namespace
                    value
                    id
                  }
                }
              }
            }
          }
        `;

        const variables = {
          queryFilter: query_filter
        };
        
        const response = await this.sendQuery(query, variables);

        if (!response.ok) {
          // throw new Error(`HTTP error ${response.status}`);
          console.log(`HTTP error ${response.status}`);
          return [];
        }

        const response_json = await response.json();

        if (typeof response_json.errors !== 'undefined') {
          console.log('[Storefront API] Error in response:', response_json.errors);
          return [];
        }

        if (typeof response_json.data === 'undefined') {
          console.log('[Storefront API] No data 1', response_json);
          return [];
        }

        if (typeof response_json.data === 'undefined' || typeof response_json.data.articles === 'undefined' || typeof response_json.data.articles.edges === 'undefined') {
          console.log('[Storefront API] No data 2', response_json);
          return [];
        }

        return response_json.data.articles.edges;
      };
      
      loadTags = async () => {
        const query = `
          query articlesTags {
            articles(first: 100) {
              edges {
                node {
                  tags
                }
              }
            }
          }
        `;

        const response = await this.sendQuery(query);

        if (!response.ok) {
          // throw new Error(`HTTP error ${response.status}`);
          console.log(`HTTP error ${response.status}`);
          return [];
        }

        const response_json = await response.json();

        if (typeof response_json.errors !== 'undefined') {
          console.log('[Storefront API] Error in response:', response_json.errors);
          return [];
        }

        if (typeof response_json.data === 'undefined') {
          console.log('[Storefront API] No data 1', response_json);
          return [];
        }

        if (typeof response_json.data === 'undefined' || typeof response_json.data.articles === 'undefined' || typeof response_json.data.articles.edges === 'undefined') {
          console.log('[Storefront API] No data 2', response_json);
          return [];
        }

        return response_json.data.articles.edges;
      };
    }

    customElements.define('study-grid', StudyGrid);
  }

  } catch(e) { console.error(e); }
})();
})();
